import { Component, ComponentFactoryResolver, HostListener, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Events, LoadingController } from 'ionic-angular';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { ComponentServiceProvider } from '../../providers/component-service/component-service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DomSanitizer } from '@angular/platform-browser';
import { PriceListTableProvider } from '../../providers/price-list-table/price-list-table';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ToastController } from 'ionic-angular';
import { AzureUploadComponent } from '../azure-upload/azure-upload';
import { ExportServiceProvider } from '../../providers/export-service/export-service';
import { HttpClient } from '@angular/common/http';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
import { PriceListComponent } from '../price-list/price-list';

declare var jQuery;
const DEFAULTINDEX = 0;
const INDEX_ONE = 1;

@Component({
  selector: 'vertical-tab',
  templateUrl: 'vertical-tab.html'
})

export class VerticalTabComponent implements OnInit {
  loader: any;
  PageHeader: boolean = false;
  components: any;
  navTemplate: any;
  tabTemplates: any = [];
  selectedSegment: any;
  showEdit: boolean = false;
  showScreen: boolean = true;
  htmlContent: any;
  countIdx: any;
  clickedSheet: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: 'Calibri',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'cambri', name: 'Cambri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
    ]
  };
  showPage: boolean = true;
  showPreview: boolean = false;
  showServiceScreen: boolean = false;
  msaScreen: boolean = false;
  serviceScreen: boolean = false;
  selectedPage: any;
  mergePage: any = [];
  companyName: any;
  @Input() params: any;
  componentRef: any;
  tabName: any = 'ProposalCreate';
  projectJSON: any;
  projectActivityJSON: any;
  projectActivityJSON1: any;
  headerValues: any;
  ShowPageHeaderVal: boolean = true;
  oneTimeHeader: any;
  monthlyHeader: any;
  Header1: any;
  Header2: any;
  pdfName: any = '';
  gstyle: any;
  htmlBodycontent: any = '';
  broadcastSubs: any;
  publishCount: any;
  constructor(public communicationServ: CommunicationServiceProvider, public http: HttpClient,public exportService: ExportServiceProvider,public toastController: ToastController, public configApiService: ConfigApiServiceProvider, public dataService: DataServiceProvider, private loadingController: LoadingController, public priceListTableService: PriceListTableProvider, public resolver: ComponentFactoryResolver, public domSanitizer: DomSanitizer, public events: Events, public componentHolderService: componentHolderService, public componentService: ComponentServiceProvider) {
    this.tabTemplates = this.componentService.tabTemplates[0]
    // this.events.subscribe('refreshData', flag => {
    //   if (flag) {
    //     setTimeout(() => {
    //       let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate');
    //       this.loadComponent(index);
    //     }, 100)
    //   }
    // });
    this.events.subscribe('ProposalPreview', (ActivatedSheet, flag) => {
      this.dataService.ClickedService = ActivatedSheet;
      this.PageHeader = true;
      this.ShowPageHeaderVal = false;
      this.headerValues = {
        buttonLabel: [{
          "name": "return",
          "action": 'return'
        }]
      };
      if (flag == true) {
        this.pdfName = this.dataService.ProposalTable.mspForm.proposalFileName;
        this.dataService.showEdit = true;
        this.dataService.showHeaderIcons = false;
        this.dataService.showPrint = true;
        this.showPreview = false;
        this.showServiceScreen = true;
        this.showPage = false;
        this.serviceScreen = true;
        this.msaScreen = false;
        setTimeout(() => {
          var data = [];
          let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer');
          var tabTemplates = this.componentService.tabTemplates[index].templates;
          var servScreen: any = [];
          servScreen.forEach(element => {
            var page = document.createElement("section")
            page.setAttribute('id', 'PreiviewCount' + data.length)
            page.setAttribute('class', 'page');
            page.innerHTML = element.htmlContent;
            data.push(page);
            this.mergePage.push(data.length);
          });
          jQuery(".serviceScreenHtml").html(data);
          tabTemplates.forEach(elem => {
            if (ActivatedSheet.includes(elem.sheetName) == true && document.getElementById('screenTable') != null) {
              document.getElementById('screenTable').innerHTML = elem.componentName;
            }
          });
          this.MspScreenActivity();
          this.projectActivity();
          this.BackupDrScreenActivity();
          this.cyberScreenActivity();
          this.hwSwScreenActivity();
          this.cloudScreenActivity();
          this.ServiceScreen();
        }, 100)
      }
    });
  }
  ngOnInit() {
    this.initapp();
    this.configApiService.getMsaMaster();
    this.configApiService.getSowMaster();
    this.configApiService.getSowListMaster();
    if(this.configApiService.pricelistMaster == undefined){
      this.configApiService.getPriceListMaster();
    }
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null) {
    this.priceListTableService.priceList = priceListData;
    }
    this.openPage();
    this.previewSow();
    this.downloadPdf();
    this.editHtml();
    this.retrieveData();
  }
  initapp(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'app-component'){
        if(data.event === 'GETAPPCOMPONENTS'){
          let flag = data['status'];
          let component = data['params'];
    if (flag) {
      this.components = component;
    }
  }
}
    });
  }
  retrieveData(){
    // this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-save'){
        if(data.event === 'SAVE_PROPOSAL'){
          let flag = data['status'];
      this.dataService.showSave = false;
      this.dataService.showHeaderIcons = false;
      var index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer');
      if (this.componentService.tabName == 'ProposalViewer') {
        this.showEdit = false;
        this.showPreview = false;
        this.showServiceScreen = false;
        this.showPage = true;
        this.componentService.tabTemplates[index].templates.forEach(element => {
          if (element.id == this.selectedPage.id && this.htmlContent != undefined) {
            return element.componentName = element.componentName.replace(element.componentName, this.htmlContent);
          }
        });
        localStorage.setItem('ViewScreen', JSON.stringify(this.componentService.tabTemplates[index].templates));
        setTimeout(() => {
          let ind = this.componentService.tabTemplates[index].templates.findIndex(item => item.id == this.selectedPage.id);
          this.openTabComponent(this.componentService.tabTemplates[index].templates[ind]);
        }, 100)
      } else if (this.componentService.tabName == 'ProposalCreate') {
        if (this.msaScreen == true) {
          let type = this.htmlContent;
          if (typeof type == "string") {
            var html = this.htmlContent.split("</div>,");
            for (var i = 0; i < this.configApiService.msaMaster.length; i++) {
              this.configApiService.msaMaster[i].jsonData = this.configApiService.msaMaster[i].jsonData.replace(this.configApiService.msaMaster[i].jsonData, html[i].concat('</div>'));
            }
          }
          setTimeout(() => {
            this.previewMsaScreen(false);
          }, 100)
        } else if (this.serviceScreen == true) {
          let type = this.htmlContent;
          if (typeof type == "string") {
            var html = this.htmlContent.split("</div>,")
            for (var i = 0; i < this.configApiService.sowMaster.length; i++) {
              this.configApiService.sowMaster[i].jsonData = this.configApiService.sowMaster[i].jsonData.replace(this.configApiService.sowMaster[i].jsonData, html[i].concat('</div>'));
            }
          }
          setTimeout(() => {
            this.previewSowScreen(this.clickedSheet, '', false);
          }, 100)
        }
      }
      const toast = this.toastController.create({
        message: 'Changes has been Saved',
        duration: 3000,
      });
      toast.present();
    }
  }
});
  }
  editHtml(){
    // this.dataService.broadcastInfo({ src: 'proposal-create', event: 'PAGE_HEADER', status: true, params: this.headerValues});
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-edit'){
        if(data.event === 'EDIT_PROPOSAL'){
        let flag = data['status'];
        this.dataService.showSave = true;
      this.dataService.showHeaderIcons = false;
      this.PageHeader = true;
      this.ShowPageHeaderVal = false;
      this.headerValues = {
        buttonLabel: [{
          "name": "return",
          "action": 'return'
        }]
      };
      if (this.componentService.tabName == 'ProposalViewer') {
        this.showEdit = flag;
        this.showPreview = false;
        this.showServiceScreen = false;
        this.showPage = true;
      } else if (this.componentService.tabName == 'ProposalCreate') {
        if (this.msaScreen == true) {
          this.showEdit = flag;
          this.showPreview = false;
          this.showServiceScreen = false;
          this.showPage = true;
          var datas = [];
          this.configApiService.msaMaster.forEach(element => {
            var page = document.createElement("section")
            page.setAttribute('id', 'PreiviewCount' + datas.length)
            page.setAttribute('class', 'page');
            page.innerHTML = element.jsonData;
            datas.push(element.jsonData);
          });
          this.htmlContent = datas;
          setTimeout(() => {
            this.MsaScreen();
          }, 100)
        } else if (this.serviceScreen == true) {
          this.showEdit = flag;
          this.showPreview = false;
          this.showServiceScreen = false;
          this.showPage = true;
          var datas = [];
          this.configApiService.sowMaster.forEach(element => {
            var page = document.createElement("section")
            page.setAttribute('id', 'PreiviewCount' + datas.length)
            page.setAttribute('class', 'page');
            page.innerHTML = element.jsonData;
            datas.push(element.jsonData);
          });
          this.htmlContent = datas;
          setTimeout(() => {
            let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer');
            var tabTemplates = this.componentService.tabTemplates[index].templates;
            tabTemplates.forEach(elem => {
              if (elem.sheetName == this.clickedSheet.name) {
                document.getElementById('screenTable').innerHTML = elem.componentName;
              }
            });
            this.MspScreenActivity();
            this.projectActivity();
            this.BackupDrScreenActivity();
            this.cyberScreenActivity();
            this.hwSwScreenActivity();
            this.cloudScreenActivity();
            this.ServiceScreen();
          }, 100)
        }
      }
    }
  }
});
  }
  downloadPdf(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-pdf'){
        if(data.event === 'GENERATE_PDF'){
          let flag = data['status'];
          if ((this.showPreview == true || this.showServiceScreen == true) && flag == true) {
            this.presentLoading();
            setTimeout(() => {
                this.generatePDF();
            }, 1000)
          }
        }
      }
    });
  }
  openPage(){
    this.broadcastSubs = this.communicationServ.getInstance()
    .subscribe((data: any) => {
      if(data.src ===  'proposal-create'){
        if(data.event === 'OPEN_PAGE'){
          let params = data['params'];
          this.tabName = data['tab'];
          this.componentService.tabName = data['tab']
          let obj={
            "name": data['tab']
          }
          this.clickedSheet = obj;
          this.openTabComponent(params);
        }else if(data.event === 'PAGE_HEADER'){
          this.PageHeader = data['status'];
          if (data['status'] == true) {
            this.headerValues = data['params'];
        }
      }else if(data.event === 'PAGE_HEADER_VALUE'){
        let headerVal = data['params'];
        if(typeof headerVal == 'string'){
          this.ShowPageHeaderVal = false;
        }else{
          this.ShowPageHeaderVal = true;
          this.Header1 = headerVal.oneTime;
          this.Header2 = headerVal.monthly;
          this.oneTimeHeader = headerVal.OneTimeValue;
          this.monthlyHeader = headerVal.monthlyValue;
        }
      }
      }
    });
  }
  previewSow() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "proposal-view") {
          if (data.event === 'PREVIEW_SOW') {
            let tabName = data['params'];
            let status = data['status'];
            this.PageHeader = true;
            this.ShowPageHeaderVal = false;
            if(status == true){
              this.headerValues = {
                buttonLabel: [{
                  "name": "return",
                  "action": 'returnScreen'
                }]
              };
            }else{
              this.headerValues = {
                buttonLabel: [{
                  "name": "return",
                  "action": 'return'
                }]
              };
            }
            this.dataService.showHeaderIcons = false;
            this.dataService.showPrint = false;
            this.showPreview = false;
            this.showServiceScreen = true;
            this.showPage = false;
            this.serviceScreen = true;
            this.msaScreen = false;
            setTimeout(() => {
              var data = [];
              let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer');
              var tabTemplates = this.componentService.tabTemplates[index].templates;
              tabTemplates.forEach(elem => {
                if (elem.sheetName == tabName) {
                  var page = document.createElement("section");
                  page.setAttribute('id', 'PreiviewCount' + data.length);
                  page.setAttribute('class', 'page');
                  page.innerHTML = elem.componentName;
                  data.push(page);
                  jQuery(".serviceScreenHtml").html(data)
                }
              });
              this.ViewSow(tabName);
            }, 100);
          }else if(data.event === 'SOW_PREVIEW'){
            let params = data['params'];
            let sowIndex = data['index'];
            let flag = data['status'];
            this.previewSowScreen(params, sowIndex, flag);
          }else if(data.event === 'MSA_PREVIEW'){
            let flag = data['status'];
            this.previewMsaScreen(flag);
          }
        }
      });
    }
    previewMsaScreen(flag){
      this.PageHeader = true;
      this.ShowPageHeaderVal = false;
      this.headerValues = {
        buttonLabel: [{
          "name": "return",
          "action": 'return'
        }]
      };
      if (flag == true) {
        this.presentLoading();
      }
        this.dataService.showEdit = true;
        this.dataService.showPrint = true;
        this.dataService.showHeaderIcons = false;
        this.showPreview = false;
        this.showServiceScreen = true;
        this.showPage = false;
        this.msaScreen = true;
        this.serviceScreen = false;
        this.mergePage = [];
        setTimeout(() => {
          var data = [];
          this.configApiService.msaMaster.forEach(element => {
            var page = document.createElement("section");
            page.setAttribute('id', 'PreiviewCount' + data.length);
            page.setAttribute('class', 'page');
            page.innerHTML = element.jsonData;
            data.push(page);
            if(this.mergePage.includes(data.length) == false){
              this.mergePage.push(data.length);
            }
          });
          jQuery(".serviceScreenHtml").html(data);
          this.MsaScreen();
          setTimeout(() => {
            if (flag == true) {
              this.generatePDF();
            }
          }, 500)
        }, 100)
    }
    previewSowScreen(params, sowIndex, flag){
      this.pdfName = params.fileName;
      this.PageHeader = true;
      this.ShowPageHeaderVal = false;
      this.headerValues = {
        buttonLabel: [{
          "name": "return",
          "action": 'return'
        }]
      };
      if (flag == true) {
        this.publishCount = sowIndex;
        this.presentLoading();
      }
      this.dataService.showEdit = true;
      this.dataService.showHeaderIcons = false;
      this.dataService.showPrint = true;
      this.showPreview = false;
      this.showServiceScreen = true;
      this.showPage = false;
      this.serviceScreen = true;
      this.msaScreen = false;
      this.clickedSheet = params;
      this.mergePage = [];
      setTimeout(() => {
        var data = [];
        let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer');
        var tabTemplates = this.componentService.tabTemplates[index].templates;
        if (localStorage.getItem('TableContent') == null) {
          // this.componentService.proposalCalculation();
        }
        var tableCont = JSON.parse(localStorage.getItem('TableContent'));
        var sections: any = [];
        tableCont.forEach(element => {
          if (element.IsChecked == true) {
            sections.push(element.SectionId);
          }
        });
        this.configApiService.sowMaster.forEach(elem => {
          // if (sections.includes(elem.SectionId) == true) {
          var page = document.createElement("section")
          page.setAttribute('id', 'PreiviewCount' + data.length)
          page.setAttribute('class', 'page');
          page.innerHTML = elem.jsonData;
          data.push(page);
          if(this.mergePage.includes(data.length) == false){
            this.mergePage.push(data.length);
          }
          // }
        });
        var cloudData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
        if(cloudData != null && cloudData.monthlyRecurring.AzureMonthly != '' && this.clickedSheet.name == 'CLD'){
          let body = `<div  class="PageContainer" style="font-family: 'calibri', 'Helvetica Neue', sans-serif;background-color: white;padding-left: 20px;padding-right: 20px;font-size: 16px !important;">
          <table>
              <thead>
                  <tr>
                      <th colspan="12" class="text-center" style="background-color: #000;padding: 5px;color: #fff;">
                          <b>Azure Worksheet</b>
                      </th>
                  </tr>
                  <tr>
                      <th colspan="12" class="text-left" style="background-color: #000;padding: 5px;color: #fff;">
                          <b>Pricing Table</b>
                      </th>
                  </tr>
              </thead>
          </table>
          <table>
              <thead>
                  <tr>
                      <th class="text-center" style="width: 15%;border-bottom: 1px solid #000;color: #000;background-color: #d0cece;padding: 2px;">
                          <b>Service type</b>
                      </th>
                      <th class="text-center" style="width: 15%;border-bottom: 1px solid #000;color: #000;background-color: #d0cece;padding: 2px;">
                          <b>Custom name</b>
                      </th>
                      <th class="text-center" style="width: 15%;border-bottom: 1px solid #000;color: #000;background-color: #d0cece;padding: 2px;">
                          <b>Region</b>
                      </th>
                      <th class="text-center" style="width: 40%;border-bottom: 1px solid #000;color: #000;background-color: #d0cece;padding: 2px;">
                          <b>Description</b>
                      </th>
                      <th class="text-center" style="width: 15%;border-bottom: 1px solid #000;color: #000;background-color: #d0cece;padding: 2px;">
                          <b>Price</b>
                      </th>
                  </tr>
              </thead>
              <tbody id="CloudAzureTable0">
                  <tr id="CloudAzureRow0">
                      <th style="width: 15%;text-align:left;color: #305496;font-size: 12px;padding: 5px;font-weight:400;border-left: 1px solid #000;border-bottom: 1px solid #000;border-right: 1px solid #000;">
                      </th>
                      <th style="width: 15%;text-align:left;color: #305496;font-size: 12px;padding: 5px;font-weight:400;border-bottom: 1px solid #000;border-right: 1px solid #000;">
                      </th>
                      <th style="width: 15%;text-align:left;color: #305496;font-size: 12px;padding: 5px;font-weight:400;border-bottom: 1px solid #000;border-right: 1px solid #000;">
                      </th>
                      <th style="width: 40%;text-align:left;color: #305496;font-size: 12px;padding: 5px;font-weight:400;border-bottom: 1px solid #000;border-right: 1px solid #000;">
                      </th>
                      <th style="width: 15%;text-align:right;color: #305496;font-size: 12px;padding: 5px;font-weight:400;border-bottom: 1px solid #000;border-right: 1px solid #000;">
                      </th>
                  </tr>
              </tbody>
          </table>
          <table>
              <tbody>
                <tr>
                  <th style="width: 30%;padding: 5px;text-align: left;background-color: #000;color: #fff;font-weight: 400;">Fee
                    Summary</th>
                  <th style="width: 10%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 25%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;">Sub Total</th>
                  <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;" id="CloudAzureSubtotal"></th>
                </tr>
                <tr>
                  <th style="width: 30%;padding: 5px;text-align: left;background-color: #000;color: #fff;"></th>
                  <th style="width: 10%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 25%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;">Tax</th>
                  <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;" id="CloudAzureTax"></th>
                </tr>
                <tr>
                  <th style="width: 30%;padding: 5px;text-align: left;background-color: #000;color: #fff;"></th>
                  <th style="width: 10%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 20%;padding: 5px;text-align: right;background-color: #000;color: #fff;"></th>
                  <th style="width: 25%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;">Total</th>
                  <th style="width: 15%;padding: 5px;text-align: right;background-color: #000;color: #fff;font-weight: 400;" id="CloudAzureTotal"></th>
                </tr>
              </tbody>
            </table>
          </div>`;
            var page = document.createElement("section")
            page.setAttribute('id', 'PreiviewCount' + data.length)
            page.setAttribute('class', 'page');
            page.innerHTML = body;
            data.push(page);
            if(this.mergePage.includes(data.length) == false){
              this.mergePage.push(data.length);
            }
        }
        jQuery(".serviceScreenHtml").html(data);
        tabTemplates.forEach(elem => {
          if (elem.sheetName == this.clickedSheet.name && document.getElementById('screenTable') != null) {
            document.getElementById('screenTable').innerHTML = elem.componentName;
          }
        });
        this.MspScreenActivity();
        this.projectActivity();
        this.BackupDrScreenActivity();
        this.cyberScreenActivity();
        this.hwSwScreenActivity();
        this.cloudScreenActivity();
        this.ServiceScreen();
        setTimeout(() => {
        if (flag == true) {
              var tab = this.clickedSheet.name.toLowerCase() + 'ContractId';
              let obj = {
                "contract_file_1_Id":  this.dataService[tab] != '' ? this.dataService[tab] : '',
                "Contract_Date": this.dataService.ProposalTable.mspForm.startDate,
                "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
                "Contract_type":  this.dataService.publishContract[sowIndex].name,
                "Contract_Status": "Published",
                "Filename":  this.dataService.publishContract[sowIndex].fileName,
                "status": "",
                "Tag": "",
                "Created_date": "",
                "Created_By": "",
                "Modified_By": "",
                "Modified_date": "",
                "jsonData": this.dataService.ProposalTable,
                "userid": 3280,
                "rptname": "contract_file_12095",
                "client": "starport1294"
              }
              let objData = { data: JSON.stringify(obj) }
              this.configApiService.saveContract(objData).subscribe(respdata => {
                if (respdata["_POST_AddMethodResult"].length > 0) {
                  if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
                    this.generatePDF();
                  }
                }
              });
        }
      }, 500)
      }, 100)
    }
    ViewSow(tab){
      if(tab == 'MSP'){
        var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
        var mspScreenData = JSON.parse(localStorage.getItem('MSPScreenData'));
        if (mspFormData != null && document.getElementById("noOfUsers") != undefined) {
          document.getElementById("noOfUsers").innerHTML = mspFormData.noOfUsers;
          document.getElementById("noOfDevices").innerHTML = mspFormData.noOfDevices;
          document.getElementById("NoOfUsers").innerHTML = mspFormData.noOfUsers;
          document.getElementById("NoOfDevices").innerHTML = mspFormData.noOfDevices;
          document.getElementById("noOfLocations").innerHTML = mspFormData.noOfLocations;
          document.getElementById('mspClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
          document.getElementById('mspMonthlyClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
          document.getElementById('MspNoteClientName').innerHTML = mspFormData.ClientCompanyName;
        }
        if (mspScreenData != null && document.getElementById("startUpDescribe") != undefined) {
          document.getElementById("startUpDescribe").innerHTML = mspScreenData.mspStartupFees.describe != '' ? mspScreenData.mspStartupFees.describe : 'One time activities to establish MSP framework include: Installation and configuration of monitoring & support tools, security account creation for remote access & creation of IT documentation & network and data maps available to us (and you) on the Starport portal';
          document.getElementById("startUpFees").innerHTML = mspScreenData.mspStartupFees.SetupConfigOneTime;
          document.getElementById("startUpCD").innerHTML = mspScreenData.mspStartupFees.CourtesyDiscountOneTime != '' ? '-' + mspScreenData.mspStartupFees.CourtesyDiscountOneTime : '';
          document.getElementById("startUpSubtotal").innerHTML = mspScreenData.mspStartupFees.subTotalStartUp;
          var mspBackupDrVal = (parseFloat(mspScreenData.mspBackupDr.TotalBackupDrOneTime != '' ? mspScreenData.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,"") : DEFAULTINDEX.toString()) + parseFloat(mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime != '' ? mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime.slice(1).replace(/  |,/gi,"") : '0')).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          document.getElementById("backUpDrOneTime").innerHTML = '$' + mspBackupDrVal;
          if(mspScreenData.mspBackupDr.describe != ''){
            document.getElementById("backUpDrDescribe").innerHTML = mspScreenData.mspBackupDr.describe;
          }else{
            document.getElementById("backUpDrDescribe").innerHTML = 'One-time Backup/DR Startup fees include: Datto - '+ mspScreenData.mspBackupDr.noOfDattoDevices +' Device  Consisting of:' + mspScreenData.mspBackupDr.dattoDevicesAndPrice +  'Intronis - ' + mspScreenData.mspBackupDr.noOfIntronisDevices + ' Device (' + mspScreenData.mspBackupDr.intronisOneTime  + ') one time.';
          }
          document.getElementById("backUpDrCDVal").innerHTML = '-' + mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime;
          document.getElementById("backUpDrSubtotal").innerHTML = mspScreenData.mspBackupDr.TotalBackupDrOneTime;
          document.getElementById("backUpDrCD").innerHTML = mspScreenData.mspBackupDr.deviceCourtesyDiscount;
          document.getElementById("MspAdditionalUser").innerHTML = mspScreenData.additionalUsers;
          document.getElementById("MspAdditionalDevice").innerHTML = mspScreenData.additionalDevices;
          var miscProductServiceDescribe = ''
          mspScreenData.miscProductService.miscProductTable.forEach(element => {
            if (element.miscOneTimeFee != '' || element.rateAndPrice || element.qtyAndAmt) {
              miscProductServiceDescribe += 'One-time Misc. Product/Service Startup fees include:' + element.miscOneTimeFee + ', (Qty: ' + element.qtyAndAmt + '@ ' + element.rateAndPrice + ', ' + 'one time.'
            }
          });
          document.getElementById("miscOneTimeDescribe").innerHTML = mspScreenData.miscProductService.describe != '' ? mspScreenData.miscProductService.describe : miscProductServiceDescribe;
          document.getElementById("miscOneTimeVal").innerHTML = mspScreenData.miscProductService.subTotalMiscOneTime;
          document.getElementById("miscOneTimeSubtotal").innerHTML = mspScreenData.miscProductService.subTotalMiscOneTime;
          document.getElementById("TotalOneTimeStartupFees").innerHTML = mspScreenData.miscProductService.totalManagedServiceOneTimeFees;
          document.getElementById("remoteConnectingHour").innerHTML = mspScreenData.mspMonthlyServices.remoteConnectingHour;
          document.getElementById("remoteConnectingTotal").innerHTML = mspScreenData.mspMonthlyServices.RemoteConnectOneTime;
          document.getElementById("endUserDesktopHour").innerHTML = mspScreenData.mspMonthlyServices.endUserDesktopHour;
          document.getElementById("EndUserOneTime").innerHTML = mspScreenData.mspMonthlyServices.EndUserOneTime;
          document.getElementById("subtotalManagedItService").innerHTML = mspScreenData.mspMonthlyServices.TotalOneTimeEffort;
          var miscFeeDescribe = ''
          mspScreenData.mspMonthlyServices.miscMonthly.forEach(element => {
            if (element.monthlyHaasSass != '' || element.rateAndPrice || element.qtyAndAmt) {
              miscFeeDescribe += 'Ongoing Misc. Products/Services Include:' + element.monthlyHaasSass + ', (Qty: ' + element.qtyAndAmt + ' @ ' + element.rateAndPrice + ', ' + 'monthly.'
            }
          });
          document.getElementById("miscFeeDescribe").innerHTML = mspScreenData.mspMonthlyServices.describe2 != '' ? mspScreenData.mspMonthlyServices.describe2 : miscFeeDescribe;
          document.getElementById("miscFeeSubtotal").innerHTML = mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime;
          document.getElementById("standBtOfficeSpace").innerHTML = mspScreenData.mspMonthlyServices.standBtOfficeSpace;
          document.getElementById("miscFeeVal").innerHTML = '$' + (parseFloat(mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime ? mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(mspScreenData.mspMonthlyServices.standBtOfficeSpace != '' ? mspScreenData.mspMonthlyServices.standBtOfficeSpace.slice(1).replace(/  |,/gi,"") : '0')).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");;
          document.getElementById("itManagementVal").innerHTML = mspScreenData.subtotalItManagementTools.subTotalSubTotal;
          var itManagementDevice = '';
          mspScreenData.itManagementTools.forEach(element => {
            if (element.incl == true) {
              itManagementDevice += element.description + ' ';
            }
          });
          if (itManagementDevice != '') {
            document.getElementById("itManagementLists").innerHTML = 'IT MANAGEMENT TOOLS: Including: ' + itManagementDevice.toLowerCase() + ' monthly';
          } else {
            document.getElementById("itManagementLists").innerHTML = '';
          }
          var additionalDevice = '';
          mspScreenData.additionalManagementTools.forEach(element => {
            if (element.incl == true) {
              additionalDevice += element.description + ' ';
            }
          });
          if (additionalDevice != '') {
            document.getElementById("additionalLists").innerHTML = 'ADDITIONAL TOOLS: Including: ' + additionalDevice.toLowerCase() + ' monthly';
          } else {
            document.getElementById("additionalLists").innerHTML = '';
          }
          document.getElementById("additionalVal").innerHTML = mspScreenData.subtotalAdditionalManagementTools.subTotalSubTotal;
          var cyberDevice = '';
          mspScreenData.cyberTools.forEach(element => {
            if (element.incl == true) {
              cyberDevice += element.description + ' ';
            }
          });
          if (cyberDevice != '') {
            document.getElementById("cyberLists").innerHTML = 'CYBER TOOLS/SERVICES: Including: ' + cyberDevice.toLowerCase() + ' monthly';
          } else {
            document.getElementById("cyberLists").innerHTML = '';
          }
          document.getElementById("cyberVal").innerHTML = mspScreenData.subtotalCyberTools.subTotalSubTotal;
          document.getElementById("mspMonthly").innerHTML = mspScreenData.mspFeesummaryTotal;
          document.getElementById("mspOneTime").innerHTML = mspScreenData.miscProductService.totalManagedServiceOneTimeFees;
          document.getElementById("discountPerMonth").innerHTML = mspScreenData.backupTools.backupProdTotalDiscount != '' ? '-' + mspScreenData.backupTools.backupProdTotalDiscount : '';
          document.getElementById("SubtotalTools").innerHTML = mspScreenData.TotalMspToolSets;
          var TotalMspSetTools = (parseFloat(mspScreenData.TotalMspToolSets != '' ? mspScreenData.TotalMspToolSets.slice(1).replace(/  |,/gi,"") : '0')
            + parseFloat(mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime != '' ? mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime.slice(1).replace(/  |,/gi,"") : '0')
            + parseFloat(mspScreenData.mspMonthlyServices.TotalOneTimeEffort != '' ? mspScreenData.mspMonthlyServices.TotalOneTimeEffort.slice(1).replace(/  |,/gi,"") : "0"));
          document.getElementById("TotalMonthlyFees").innerHTML = TotalMspSetTools != DEFAULTINDEX ? '$' + TotalMspSetTools.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
          var backuptools = '';
          mspScreenData.backupTools.backupProdTable.forEach(element => {
            if (element.quantity != '') {
              backuptools += element.backUpProdName + ' -' + element.describe + ' (' + element.price + '),';
            }
          });
          let datto = mspScreenData.mspBackupDr.dattoMonthly != '' ? (mspScreenData.mspBackupDr.dattoDevicesOnly + ' = ' + mspScreenData.mspBackupDr.dattoMonthly) : '';
          let intronis = mspScreenData.mspBackupDr.intronisMonthly != '' ? (mspScreenData.mspBackupDr.intronisDevicesOnly + ' = ' + mspScreenData.mspBackupDr.intronisMonthly) : '';
          let backupiFy = mspScreenData.mspBackupDr.backupifyMonthly != '' ? (' = ' + mspScreenData.mspBackupDr.backupifyMonthly) : '';
          if (backuptools != '' || datto != '' || intronis != '' || backupiFy != '') {
            let backp1 = datto != '' ? 'Datto: ' + datto + '. ' : '';
            let backp2 = intronis != '' ? 'Intronis: ' + intronis + '. ' : '';
            let backp3 = backupiFy != '' ? 'Backupify: ' + backupiFy + '. ' : '';
            document.getElementById("backupToolsLists").innerHTML = 'BACKUP TOOLS ' + backp1 + backp2 + backp3 + backuptools + ', monthly.';
          } else {
            document.getElementById("backupToolsLists").innerHTML = '';
          }
          document.getElementById("mspStandByOfficeVal").innerHTML = mspScreenData.mspMonthlyServices.standBtOfficeSpace;
          document.getElementById("backupToolsVal").innerHTML = mspScreenData.backupTools.totalBackupMonthlyPrice;
          document.getElementById("IncDiscountMonth").innerHTML = mspScreenData.DiscountMonth;
          document.getElementById("DiscountMonth").innerHTML = mspScreenData.DiscountMonth;
            if (mspScreenData.mspMonthlyServices.EndUserOneTime == '' && document.getElementById('mspMonthlyManageEnd') != undefined) {
              document.getElementById('mspMonthlyManageEnd').style.display = 'none';
            }
            if (mspScreenData.miscProductService.subTotalMiscOneTime == '') {
              document.getElementById('mspMisc1').style.display = 'none';
              document.getElementById('mspMisc2').style.display = 'none';
              document.getElementById('mspMisc3').style.display = 'none';
            }
            if (mspScreenData.mspStartupFees.subTotalStartUp == '') {
              document.getElementById('mspManagedService1').style.display = 'none';
              document.getElementById('mspManagedService2').style.display = 'none';
            }
            if (mspScreenData.miscProductService.totalManagedServiceOneTimeFees == '') {
              document.getElementById('mspMisc1').style.display = 'none';
              document.getElementById('mspMisc2').style.display = 'none';
            }
            if (mspScreenData.mspMonthlyServices.TotalOneTimeEffort == '') {
              document.getElementById('MonthlyFeesDescribe').style.display = 'none';
              document.getElementById('mspMonthlyManageIt1').style.display = 'none';
              document.getElementById('mspMonthlyManageIt2').style.display = 'none';
              document.getElementById('mspMonthlyManageIt3').style.display = 'none';
            }
            if (mspScreenData.backupTools.backupProdTotalDiscount == '') {
              document.getElementById('MspMonthlySect').style.display = 'none';
            }
            if (mspScreenData.mspStartupFees.CourtesyDiscountOneTime == '') {
              document.getElementById('MSPShowStartupDiscount').style.display = 'none';
            }
            if (mspScreenData.mspMonthlyServices.standBtOfficeSpace == '') {
              document.getElementById("standBtOfficeSpaceReq").style.visibility = 'hidden';
            }
            if (mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime == '' && mspScreenData.mspMonthlyServices.standBtOfficeSpace == '') {
              document.getElementById('mspMiscFee1').style.display = 'none';
              document.getElementById('mspMiscFee2').style.display = 'none';
            } else if (mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime == '') {
              document.getElementById('mspMiscFee1').style.display = 'none';
            }
            if(mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
              document.getElementById("mspBackupDrDiscount").style.display = 'none';
            }
            if (TotalMspSetTools == DEFAULTINDEX) {
              document.getElementById('MSPMonthly1').style.display = 'none';
              document.getElementById('MSPMonthly2').style.display = 'none';
              document.getElementById('MSPMonthly3').style.display = 'none';
              document.getElementById('MSPMonthly4').style.display = 'none';
              document.getElementById('mspItAddCyberBackup2').style.display = 'none';
              document.getElementById('mspItAddCyberBackup1').style.display = 'none';
              document.getElementById('mspMiscFee2').style.display = 'none';
              document.getElementById('mspMiscFee1').style.display = 'none';
              document.getElementById('mspMonthlyManageIt3').style.display = 'none';
              document.getElementById('mspMonthlyManageIt2').style.display = 'none';
            }
            if (mspScreenData.subtotalItManagementTools.subTotalSubTotal == '') {
              document.getElementById('mspItManagement').style.display = 'none';
            }
            if (mspBackupDrVal == '' || mspBackupDrVal == "0.00") {
              document.getElementById('mspbackupDr1').style.display = 'none';
              document.getElementById('mspbackupDr2').style.display = 'none';
            }
            if (mspScreenData.subtotalAdditionalManagementTools.subTotalSubTotal == '') {
              document.getElementById('mspAdditional').style.display = 'none';
            }
            if (mspScreenData.subtotalCyberTools.subTotalSubTotal == '') {
              document.getElementById('mspCyber').style.display = 'none';
            }
            if (mspScreenData.backupTools.totalBackupMonthlyPrice == '') {
              document.getElementById('mspBackupTools').style.display = 'none';
            }
            if (mspScreenData.backupTools.backupProdTotalDiscount == '') {
              document.getElementById('showMspDiscount').style.display = 'none';
            }
            if (mspScreenData.TotalMspToolSets == '') {
              document.getElementById('mspItAddCyberBackup1').style.display = 'none';
              document.getElementById('mspItAddCyberBackup2').style.display = 'none';
            }
        }
      }else if(tab == 'CYB'){
        var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
        var cyberScreenData = JSON.parse(localStorage.getItem('CYBERScreenData'));
        if (mspFormData != null && document.getElementById("CyberNoOfUsers") != undefined) {
          document.getElementById("CyberNoOfUsers").innerHTML = mspFormData.noOfUsers;
          document.getElementById("CyberNoOfDevices").innerHTML = mspFormData.noOfDevices;
          document.getElementById("CyberNoOfLocations").innerHTML = mspFormData.noOfLocations;
          document.getElementById('cyberClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
          document.getElementById('cyberNoteClientName').innerHTML = mspFormData.ClientCompanyName;
        }
        var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
        if (priceListData != null && document.getElementById('CyberHourly') != undefined) {
          document.getElementById('CyberHourly').innerHTML = priceListData.TotalCyberHourly;
        } else if (priceListData == null && document.getElementById('CyberHourly') != undefined) {
          document.getElementById('CyberHourly').innerHTML = this.priceListTableService.priceList.defCyberHourly;
        }
        if (cyberScreenData != null && document.getElementById('CyberTotalmonthlyFee') != undefined) {
          document.getElementById("CyberTotalmonthlyFee").innerHTML = cyberScreenData.totalBackupDrMonthlyTool;
          document.getElementById("CyberOneTime").innerHTML = cyberScreenData.oneTimeFee.TotalStartUp;
          var CyberMonthlyTableVal = parseFloat(cyberScreenData.totalBackupDrMonthlyTool != '' ? cyberScreenData.totalBackupDrMonthlyTool.slice(1).replace(/  |,/gi,"") : '0') + parseFloat(cyberScreenData.backupProdTotalDiscount != '' ? cyberScreenData.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") :  '0');
          if(CyberMonthlyTableVal != DEFAULTINDEX){
            document.getElementById("CyberMMSMToolFee").innerHTML = '$' + CyberMonthlyTableVal.toFixed(2);
          }
          var additionalDevice = '';
          cyberScreenData.additionalManagementTools.forEach(element => {
            if (element.incl == true) {
              additionalDevice += element.description + ' ';
            }
          });
          if (additionalDevice != '') {
            document.getElementById("CyberAdditionalToolDescribe").innerHTML = 'ADDITIONAL TOOLS: Including: ' + additionalDevice.toLowerCase() + ' monthly';
          } else {
            document.getElementById("CyberAdditionalToolDescribe").innerHTML = '';
          }
          document.getElementById("CyberAToolServiceValue").innerHTML = cyberScreenData.subtotalAdditionalManagementTools.subTotalSubTotal;
          var cyberDevice = '';
          cyberScreenData.cyberTools.forEach(element => {
            if (element.incl == true) {
              cyberDevice += element.description + ' ';
            }
          });
          if (cyberDevice != '') {
            document.getElementById("CyberCToolDescribe").innerHTML = 'CYBER TOOLS/SERVICES: Including: ' + cyberDevice.toLowerCase() + ' monthly';
          } else {
            document.getElementById("CyberCToolDescribe").innerHTML = '';
          }
          // if(document.getElementById("CyberCToolServiceValue") != null){
            document.getElementById("CyberCToolServiceValue").innerHTML = cyberScreenData.subtotalCyberTools.subTotalSubTotal;
          // }
          if (document.getElementById('CyberAdditionalUsers') != null) {
            document.getElementById('CyberAdditionalUsers').innerHTML = cyberScreenData.additionalUsers;
          }
          if (document.getElementById('CyberAdditionalDevices') != null) {
            document.getElementById('CyberAdditionalDevices').innerHTML = cyberScreenData.additionalDevices;
          }
          document.getElementById('CyberDiscountMonthSect').innerHTML = cyberScreenData.DiscountMonth;
          document.getElementById('CyberdiscountPerMonth').innerHTML = '-' + cyberScreenData.backupProdTotalDiscount;
          document.getElementById('CyberDiscountMonth').innerHTML = cyberScreenData.DiscountMonth;
          document.getElementById('cyberDescribe').innerHTML = cyberScreenData.oneTimeFee.describeStartupFees != '' ? cyberScreenData.oneTimeFee.describeStartupFees : 'One time activities to implement security tools and processes to establish Cyber724 framework for the delivery of Managed Security Services.';
          document.getElementById('CyberSubtotalOneTime').innerHTML = cyberScreenData.oneTimeFee.SetupConfigOneTime;
          document.getElementById('CyberCourtesyDiscount').innerHTML = '-' + cyberScreenData.oneTimeFee.CourtesyDiscountOneTime;
          document.getElementById('CyberTotalOneTimeStartupFees').innerHTML = cyberScreenData.oneTimeFee.TotalStartUp;
            if(cyberScreenData.subtotalAdditionalManagementTools.subTotalSubTotal == ''){
              document.getElementById('CyberAToolTable').style.display = 'none';
            }
            if(cyberScreenData.subtotalCyberTools.subTotalSubTotal == ''){
              document.getElementById('CyberCToolTable').style.display = 'none';
            }
            if(CyberMonthlyTableVal == DEFAULTINDEX){
              document.getElementById('CyberCToolTable').style.display = 'none';
              document.getElementById('CyberAToolTable').style.display = 'none';
              document.getElementById('CyberMonthly1').style.display = 'none';
              document.getElementById('CyberMonthly2').style.display = 'none';
              document.getElementById('CyberMonthly3').style.display = 'none';
              document.getElementById('CyberMonthly4').style.display = 'none';
            }
            if (cyberScreenData.oneTimeFee.CourtesyDiscountOneTime == '') {
              document.getElementById('cyberStartup2Discount').style.display = 'none';
            }
            if(cyberScreenData.backupProdTotalDiscount == ''){
              document.getElementById('CyberMonthlySect').style.display = 'none';
              document.getElementById('cyberShowDisount').style.display = 'none';
            }
            if (cyberScreenData.oneTimeFee.TotalStartUp == '') {
              document.getElementById('cyberStartup1').style.display = 'none';
              document.getElementById('cyberStartup2').style.display = 'none';
            }
            if (cyberScreenData.backupProdTotalDiscount == '') {
              document.getElementById('CyberDiscountMonth').style.display = 'none';
            }
        }
      }else if(tab == 'CLD'){
        var CloudFormData = JSON.parse(localStorage.getItem('MSPForm'));
        var cloudData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
        if (CloudFormData != null && document.getElementById("CloudNoOfUsers") != undefined) {
          document.getElementById("CloudNoOfUsers").innerHTML = CloudFormData.noOfUsers;
          document.getElementById('cloudClientName').innerHTML = ' - ' + CloudFormData.ClientCompanyName;
        }
        if (cloudData != null && document.getElementById("CloudMonthlyFee") != undefined) {
          document.getElementById("cloudStartupDescribe").innerHTML = cloudData.startUpDescribe != '' ? cloudData.startUpDescribe : 'Conduct one time activities  to configure servers with specified disk, cpu and memory. Install and patch operating systems, configure firewalls, routers and vLans, setup access rights and permissions and communicate same to the client side technical community and end users.  Test to ensure access and security is functioning as expected.';
          document.getElementById("CloudSubtotalOneTime").innerHTML = cloudData.SetupConfigOneTime;
          document.getElementById("CloudCourtesyDiscount").innerHTML = '-' + cloudData.CourtesyDiscountOneTime;
          document.getElementById("CloudTotalOneTimeStartupFees").innerHTML = cloudData.TotalStartUp;
          document.getElementById("CloudSubtotalOneTime").innerHTML = cloudData.SetupConfigOneTime;
          document.getElementById("CloudSubtotalHostingServices").innerHTML = cloudData.monthlyRecurring.oneTime;
          document.getElementById("CloudMonthlyRecurringHours").innerHTML = cloudData.monthlyRecurring.oneTime;
          document.getElementById("cloudHostingServiceDescribe").innerHTML = cloudData.monthlyRecurring.describe != '' ? cloudData.monthlyRecurring.describe : 'Monitoring and responding to any server or network related alerts; monthy patching and reboots of all servers in the environment  capacity monitoring and adjustment based on server loads and carrying out adds, changes and deletes in the cloud infrastructure as requested/required.';
          document.getElementById("CloudAzureHostingDescribe").innerHTML = cloudData.monthlyRecurring.AzureServiceDescribe != '' ? cloudData.monthlyRecurring.AzureServiceDescribe : 'Azure production hosting, including Watchguard Firewalls in the production and DR environments and the DR environment using Site Recovery.';
          document.getElementById("CloudAzureHostingSubTotal").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
          document.getElementById("CloudAzureHostingSubTotal1").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
          var NoOfServer = [];
          cloudData.monthlyRecurring.IaaS.forEach(element => {
            if (element.serverName != '') {
              NoOfServer.push(element.base);
            }
          });
          document.getElementById("CloudNoOfServer").innerHTML = NoOfServer.length.toString();
          var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
          if (priceListData != null) {
            this.priceListTableService.priceList.CloudServerAndSW.server.SellValue = priceListData.CloudServerAndSW.server.SellValue;
            this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue = priceListData.CloudServerAndSW.cpu.SellValue;
            this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue = priceListData.CloudServerAndSW.ram.SellValue;
            this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue = priceListData.CloudServerAndSW.disk.SellValue;
          } else {
            if (this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn != '') {
              var diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            } else {
              diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            }
            if (this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn != '') {
              var ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            } else {
              ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            }
            if (this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn != '') {
              var cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            } else {
              cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            }
            if (this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn != '') {
              var serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            } else {
              serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
            }
            this.priceListTableService.priceList.CloudServerAndSW.server.SellValue = '$' + serverVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue = '$' + cpuVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue = '$' + ramVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue = '$' + diskVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
          document.getElementById("serverVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.server.SellValue;
          document.getElementById("cpuVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue;
          document.getElementById("ramVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue;
          document.getElementById("diskVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue;
          document.getElementById("TotalServerVal").innerHTML = cloudData.monthlyRecurring.TotalBase;
          document.getElementById("TotalCpuVal").innerHTML = cloudData.monthlyRecurring.TotalCpu;
          document.getElementById("TotalRamVal").innerHTML = cloudData.monthlyRecurring.TotalRam;
          document.getElementById("TotalDiskVal").innerHTML = cloudData.monthlyRecurring.TotalDisk;
          document.getElementById("CloudSubtotalInfraIaaS").innerHTML = cloudData.monthlyRecurring.SubtotalIaaS;
          var monthRecurringSaas = '';
          cloudData.monthlyRecurring.SaaS.forEach(element => {
            if (element.item != '' && element.qty != '') {
              monthRecurringSaas += 'Monthly Recurring Software (SaaS) : ' + element.item + ', (Qty: ' + element.qty + ' @ ' + element.price + '), ' + 'monthly.'
            }
          });
          document.getElementById("CloudSoftwareIaasDescribe").innerHTML = monthRecurringSaas;
          document.getElementById("CloudSubtotalSoftwareIaaS").innerHTML = cloudData.monthlyRecurring.SubTotalSaaS;
          var miscellaneous = [];
          cloudData.monthlyRecurring.miscellaneous.forEach(element => {
            var ToolDes = '';
            if (element.tools != '' || element.description != '') {
              ToolDes = ' : '
            } else {
              ToolDes = ''
            }
            if (element.price != '') {
              let obj = {
                "Service": element.tools + ToolDes + element.description,
                "Price": element.price
              }
              miscellaneous.push(obj);
            }
          });
          var Cloudcol = [];
          for (var i = 0; i < miscellaneous.length; i++) {
            for (var key in miscellaneous[i]) {
              if (Cloudcol.indexOf(key) === -1) {
                Cloudcol.push(key);
              }
            }
          }
          for (var i = 0; i < miscellaneous.length; i++) {
            var tableRow = document.getElementById('cloudJSON0')
            var table = document.getElementById("cloudTableToModify"); // find table to append to
            var clone = tableRow.cloneNode(true);
            clone['id'] = "cloudJSON0" + (i + 1); // change id or other attributes/contents
            table.appendChild(clone)
            var name = `#cloudJSON0${i + 1} th`
            var data = document.querySelectorAll(name)
            for (var j = 0; j < Cloudcol.length; j++) {
              data[j].innerHTML = miscellaneous[i][Cloudcol[j]]
            }
          }
          document.getElementById("CloudSubtotalOtherPS").innerHTML = cloudData.monthlyRecurring.SubTotalMiscellaneous;
          document.getElementById("CloudTotalMonthlyFees").innerHTML = cloudData.monthlyRecurring.TotalMonthlyRecurring;
          document.getElementById("CloudMonthlyFee").innerHTML = cloudData.FeesummaryMonthlyTotal;
          document.getElementById("CloudOneTImeFee").innerHTML = cloudData.TotalStartUp;
          document.getElementById("CloudDiscountMonth").innerHTML = cloudData.DiscountMonth;
          document.getElementById("ClouddiscountPerMonth").innerHTML = '-' + cloudData.monthlyRecurring.cloudMonthlyTotalDiscount;
          document.getElementById("CloudDiscountMonthSect").innerHTML = cloudData.DiscountMonth;
         if(cloudData.monthlyRecurring.AzureMonthly != ''){
          var CloudAzurecol = [];
          for (var i = 0; i < cloudData.AzureServices.AzureTable.length; i++) {
            for (var key in cloudData.AzureServices.AzureTable[i]) {
              if (CloudAzurecol.indexOf(key) === -1) {
                CloudAzurecol.push(key);
              }
            }
          }
          for (var i = 0; i < cloudData.AzureServices.AzureTable.length; i++) {
            var cloudtableRow = document.getElementById('CloudAzureRow0')
            var cloudtable = document.getElementById("CloudAzureTable0"); // find table to append to
            var cloudclone = cloudtableRow.cloneNode(true);
            cloudclone['id'] = "CloudAzureRow0" + (i + 1); // change id or other attributes/contents
            cloudtable.appendChild(cloudclone)
            var cloudname = `#CloudAzureRow0${i + 1} th`
            var clouddata = document.querySelectorAll(cloudname)
            for (var j = 0; j < CloudAzurecol.length; j++) {
              clouddata[j].innerHTML = cloudData.AzureServices.AzureTable[i][CloudAzurecol[j]]
            }
          }
          cloudtableRow.style.display = 'none';
          document.getElementById("CloudAzureSubtotal").innerHTML = cloudData.monthlyRecurring.AzureSubTotal;
          document.getElementById("CloudAzureTax").innerHTML = cloudData.monthlyRecurring.AzureTax;
          document.getElementById("CloudAzureTotal").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
        }
            if (cloudData.monthlyRecurring.TotalMonthlyRecurring == '' && document.getElementById('CloudMonthlyTable1') != null) {
              document.getElementById('CloudMonthlyTable1').style.display = 'none';
              document.getElementById('CloudMonthlyTable2').style.display = 'none';
            }
            if(cloudData.monthlyRecurring.cloudMonthlyTotalDiscount == ''){
              document.getElementById("CloudMonthlySect").style.display = 'none';
              document.getElementById('showCloudDiscount').style.display = 'none';
            }
            if(cloudData.monthlyRecurring.AzureMonthly == ''){
              document.getElementById("CloudAzureHosting").style.display = 'none';
              document.getElementById("CloudAzureHosting1").style.display = 'none';
            }
            if (cloudData.CourtesyDiscountOneTime == '') {
              document.getElementById('cloudCourtesyShow').style.display = 'none';
            }
            if (document.getElementById('cloudJSON0') != undefined && document.getElementById('cloudJSON0') != null) {
              document.getElementById('cloudJSON0').style.display = 'none';
            }
            if (cloudData.TotalStartUp == '') {
              document.getElementById('cloudStartup1').style.display = 'none';
              document.getElementById('cloudStartup2').style.display = 'none';
            }
            if (cloudData.monthlyRecurring.oneTime == '') {
              document.getElementById("CloudHosting1").style.display = 'none';
              document.getElementById("CloudHosting2").style.display = 'none';
              document.getElementById("CloudHosting3").style.display = 'none';
            }
            if (cloudData.monthlyRecurring.SubTotalSaaS == '') {
              document.getElementById("CloudIaaS1").style.display = 'none';
              document.getElementById("CloudIaaS2").style.display = 'none';
              document.getElementById("CloudIaaS3").style.display = 'none';
            }
            if (cloudData.monthlyRecurring.SubTotalMiscellaneous == '') {
              document.getElementById("CloudMiscellaneous1").style.display = 'none';
              document.getElementById("CloudMiscellaneous2").style.display = 'none';
            }
            if (cloudData.monthlyRecurring.SubtotalIaaS == '') {
              document.getElementById("CloudInfra1").style.display = 'none';
              document.getElementById("CloudInfra2").style.display = 'none';
              document.getElementById("CloudInfra3").style.display = 'none';
            }
        }
      }else if(tab == 'BKP'){
        var backupDrFormData = JSON.parse(localStorage.getItem('MSPForm'));
        var backupDrData = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
        if (backupDrFormData != null && document.getElementById("BackupDrNoOfUsers") != undefined) {
          document.getElementById("BackupDrNoOfUsers").innerHTML = backupDrFormData.noOfUsers;
          document.getElementById("BackupDrNoOfDevices").innerHTML = backupDrFormData.noOfDevices;
          document.getElementById("BackupDrNoOfLocations").innerHTML = backupDrFormData.noOfLocations;
          document.getElementById('backupdrClientName').innerHTML = ' - ' + backupDrFormData.ClientCompanyName;
          document.getElementById("BkpNoteClientCompanyName").innerHTML = backupDrFormData.ClientCompanyName;
        }
        if (backupDrData != null && document.getElementById("backupDrOneTimeDescribe") != undefined) {
          document.getElementById("BackupDrTotalOneTimeStartupFees").innerHTML = backupDrData.totalBackupDrServiceOneTimeFees;
          var totalBackupOneTimeFee = parseFloat(backupDrData.mspBackupDr.dattoOneTime != '' ? backupDrData.mspBackupDr.dattoOneTime.slice(1).replace(/  |,/gi,"") : '0') + parseFloat(backupDrData.mspBackupDr.intronisOneTime != '' ? backupDrData.mspBackupDr.intronisOneTime.slice(1).replace(/  |,/gi,"") : '0');
          document.getElementById("TotalBackupDrOneTime").innerHTML = '$' + totalBackupOneTimeFee.toFixed(2);
          document.getElementById("BackupDrTotalMonthlyFees").innerHTML = backupDrData.BackupFeesummaryTotaly;
          document.getElementById("BackupDrMonthlyFees").innerHTML = backupDrData.backupTools.totalBackupDrMonthlyTool;
          document.getElementById("backupDrMonthly").innerHTML = backupDrData.BackupFeesummaryTotaly;
          document.getElementById("backupDrOneTime").innerHTML = backupDrData.totalBackupDrServiceOneTimeFees;
          document.getElementById("BackupDrDiscountMonth").innerHTML = backupDrData.DiscountMonth;
          document.getElementById("backUpDrMonthlyDiscount").innerHTML = backupDrData.DiscountMonth;
          document.getElementById("backUpDrMonthlyDiscountVal").innerHTML = '-' + backupDrData.backupTools.backupProdTotalDiscount;
          document.getElementById("backUpDrOneTimeDiscntPercent").innerHTML = backupDrData.mspBackupDr.deviceCourtesyDiscount;
          document.getElementById("BkpBackupDrOneTimeDiscount").innerHTML = '-' + backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime;
          document.getElementById("BkpBackupDrSubtotal").innerHTML = backupDrData.mspBackupDr.TotalBackupDrOneTime;
          document.getElementById("backUpDrStartupSubtotal").innerHTML = backupDrData.oneTimeFee.subTotalStartUp;
          document.getElementById("backUpDrOneTimeDiscount").innerHTML = backupDrData.oneTimeFee.CourtesyDiscountOneTime;
          document.getElementById("BkpStartupOneTime").innerHTML = backupDrData.oneTimeFee.SetupConfigOneTime;
          document.getElementById("backupDrStartupDescribe").innerHTML = backupDrData.oneTimeFee.describeStartupFees != '' ?  backupDrData.oneTimeFee.describeStartupFees : 'One time activities to establish and test the Backup and Disaster Recovery framework.';
          var backuptools = '';
          backupDrData.backupTools.backupProdTable.forEach(element => {
            if (element.quantity != '') {
              backuptools += element.backUpProdName + ' -' + element.describe + ' (' + element.price + '), ';
            }
          });
          let datto = backupDrData.mspBackupDr.dattoMonthly != '' ? backupDrData.mspBackupDr.dattoDevicesOnly : '';
          let intronis = backupDrData.mspBackupDr.intronisMonthly != '' ? backupDrData.mspBackupDr.intronisDevicesOnly : '';
          let backupiFy = backupDrData.mspBackupDr.backupifyMonthly != '' ? backupDrData.mspBackupDr.backupifyDevicesOnly : '';
          if (backuptools != '' || datto != '' || intronis != '' || backupiFy != '') {
            let backp1 = datto != '' ? 'Datto - (' + datto + '), ' : '';
            let backp2 = intronis != '' ? 'Intronis - (' + intronis + '), ' : '';
            let backp3 = backupiFy != '' ? 'Backupify - (' + backupiFy + '), ' : '';
            document.getElementById("BackupDrBackupToolsLists").innerHTML = 'BACKUP TOOLS ' + backp1 + backp2 + backp3 + backuptools + ', monthly.';
          } else {
            document.getElementById("BackupDrBackupToolsLists").innerHTML = '';
          }
          let dattoDev = backupDrData.mspBackupDr.dattoOneTime != '' ? 'Datto - ' + backupDrData.mspBackupDr.noOfDattoDevices + ' Devices (' + backupDrData.mspBackupDr.dattoOneTime + '), ' : '';
          let intronisDev = backupDrData.mspBackupDr.intronisOneTime != '' ? 'Intronis - ' + backupDrData.mspBackupDr.noOfIntronisDevices + ' Devices (' + backupDrData.mspBackupDr.intronisOneTime  + '),' : '';
          document.getElementById("backupDrOneTimeDescribe").innerHTML = 'One-time Backup/DR Startup fees include: ' + dattoDev + intronisDev +  ' one time.';
          if(backupDrData.oneTimeFee.CourtesyDiscountOneTime == ''){
            document.getElementById("BackupdrStarup5").style.display = 'none';
          }
          if(backupDrData.oneTimeFee.SetupConfigOneTime == ''){
            document.getElementById("BackupdrStarup11").style.display = 'none';
            document.getElementById("BackupdrStarup3").style.display = 'none';
          }
          if(backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
            document.getElementById("BackupdrStarup9").style.display = 'none';
          }
          if(totalBackupOneTimeFee == DEFAULTINDEX){
            document.getElementById("BackupdrStarup8").style.display = 'none';
            document.getElementById("BackupdrStarup12").style.display = 'none';
          }
          if(backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
            document.getElementById("BackupdrStarup9").style.display = 'none';
          }
          if(backupDrData.oneTimeFee.subTotalStartUp == ''){
            document.getElementById("BackupdrStarup2").style.display = 'none';
            document.getElementById("BackupdrStarup3").style.display = 'none';
          }
          if(backupDrData.mspBackupDr.TotalBackupDrOneTime == ''){
            document.getElementById("BackupdrStarup6").style.display = 'none';
            document.getElementById("BackupdrStarup7").style.display = 'none';
            document.getElementById("BackupdrStarup13").style.display = 'none';
            document.getElementById("BackupdrStarup14").style.display = 'none';
          }
          if(backupDrData.totalBackupDrServiceOneTimeFees == ''){
            document.getElementById("BackupdrStarup1").style.display = 'none';
            document.getElementById("BackupdrStarup2").style.display = 'none';
            document.getElementById("BackupdrStarup3").style.display = 'none';
            document.getElementById("BackupdrStarup6").style.display = 'none';
            document.getElementById("BackupdrStarup7").style.display = 'none';
            document.getElementById("BackupdrStarup10").style.display = 'none';
          }
          if(backupDrData.backupTools.totalBackupDrMonthlyTool == ''){
            document.getElementById("BackupdrMonthly2").style.display = 'none';
            document.getElementById("BackupdrMonthly3").style.display = 'none';
          }
          if(backupDrData.backupTools.backupProdTotalDiscount == ''){
            document.getElementById("BackupdrMonthly6").style.display = 'none';
          }
          if(backupDrData.BackupFeesummaryTotaly == ''){
            document.getElementById("BackupdrMonthly1").style.display = 'none';
            document.getElementById("BackupdrMonthly2").style.display = 'none';
            document.getElementById("BackupdrMonthly3").style.display = 'none';
            document.getElementById("BackupdrMonthly4").style.display = 'none';
            document.getElementById("BackupdrMonthly5").style.display = 'none';
            document.getElementById("BackupdrMonthly6").style.display = 'none';
            document.getElementById("BackupdrMonthly7").style.display = 'none';
            document.getElementById("BackupdrMonthly8").style.display = 'none';
          }
          if(backupDrData.backupTools.backupProdTotalDiscount == ''){
            document.getElementById("showBkpDiscount").style.display = 'none';
          }
        }
      }else if(tab == 'HW'){
        var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
        if (mspFormData != null && document.getElementById("hwswClientName") != undefined) {
          document.getElementById('hwswClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
        }
        var hwSwScreenData = JSON.parse(localStorage.getItem('HWSWScreenData'));
        if (hwSwScreenData != null && document.getElementById('HWSWTable') != undefined) {
          var hstVal = (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) * 0.13).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          if (hwSwScreenData.leaseOrPurchase == 'lease') {
            document.getElementById('HWSWFeeSummaryLP').innerHTML = 'See Lease Detail Above';
            document.getElementById('LeaseOrPurchase').innerHTML = 'Lease';
            document.getElementById('HWSWleaseDetail').innerHTML = '';
            document.getElementById('HWSWLeaseTotal').innerHTML = '';
            document.getElementById('HWSWLeaseHst').innerHTML = '';
            document.getElementById('HWSWHst').innerHTML = '';
            document.getElementById('HWSWTotal').innerHTML = '';
          } else if (hwSwScreenData.leaseOrPurchase == 'purchase') {
            document.getElementById('HidePurchase').style.display = 'none';
            document.getElementById('LeaseOrPurchase').innerHTML = 'Purchase';
            document.getElementById('HWSWFeeSummaryLP').innerHTML = 'Purchase Price';
            document.getElementById('HWSWleaseDetail').innerHTML = hwSwScreenData.TotalExtendedPrice;
            document.getElementById('HWSWHst').innerHTML = '$' + hstVal;
            document.getElementById('HWSWTotal').innerHTML = '$' + (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) + parseFloat(hstVal)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          } else {
            document.getElementById('HWSWFeeSummaryLP').innerHTML = 'See Lease Detail Above';
            document.getElementById('LeaseOrPurchase').innerHTML = 'Lease';
            document.getElementById('HWSWleaseDetail').innerHTML = hwSwScreenData.TotalExtendedPrice;
            document.getElementById('HWSWHst').innerHTML = '$' + hstVal;
            document.getElementById('HWSWTotal').innerHTML = '$' + (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) + parseFloat(hstVal)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
          }
          var hwswcol = [];
          var HwSwTableData = [];
          hwSwScreenData.contractLineItems.forEach(element => {
            if (element.extendedPrice != '') {
              let obj = {
                "qty": element.qty,
                "description": element.description,
                "unit": element.unitPrice,
                "extended": element.extendedPrice
              }
              HwSwTableData.push(obj);
            }
          });
          for (var i = 0; i < HwSwTableData.length; i++) {
            for (var key in HwSwTableData[i]) {
              if (hwswcol.indexOf(key) === -1) {
                hwswcol.push(key);
              }
            }
          }
          for (var i = 0; i < HwSwTableData.length; i++) {
            var tableRow1 = document.getElementById('HwSwRow0')
            var table1 = document.getElementById("HWSWTable");
            var clone1 = tableRow1.cloneNode(true);
            clone1['id'] = "HwSwRow0" + (i + 1);
            table1.appendChild(clone1)
            var name1 = `#HwSwRow0${i + 1} th`
            var data1 = document.querySelectorAll(name1)
            for (var j = 0; j < hwswcol.length; j++) {
              data1[j].innerHTML = HwSwTableData[i][hwswcol[j]]
            }
          }
          if (tableRow1 != undefined) {
            tableRow1.style.display = 'none';
          }
          document.getElementById('leaseOrPurchaseDescription').innerHTML = hwSwScreenData.leaseOrPurchaseDescription;
          document.getElementById('HWSWleaseLen').innerHTML = hwSwScreenData.Months;
          document.getElementById('HWSWduration').innerHTML = hwSwScreenData.OfDuration != '' ? hwSwScreenData.OfDuration : DEFAULTINDEX.toString();
          document.getElementById('HWSWfirstInvDate').innerHTML = hwSwScreenData.firstInvDate;
          document.getElementById('HWSWlastInvDate').innerHTML = hwSwScreenData.lastInvDate;
          document.getElementById('HWSWfirstLastMnthPmt').innerHTML = hwSwScreenData.firstLastMnthPmt;
          document.getElementById('HWSWregMonthPmt').innerHTML = hwSwScreenData.TotalMonthlyLeaseAmt;
          document.getElementById('HWSWnextMonths').innerHTML = hwSwScreenData.OfDuration != '' ? hwSwScreenData.OfDuration : DEFAULTINDEX.toString();
        }
      }else if(tab == 'PJT'){
        var projectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
        var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
        if (mspFormData != null && document.getElementById("projectClientName") != undefined) {
          document.getElementById('projectClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
        }
        if (projectScreenData != null && document.getElementById('projectActivityTable') != undefined) {
          var projectHourlycol = [];
          var projHours = [];
          projectScreenData.projectService.Hourly.forEach(element => {
            if (element.total != '') {
              let obj = {
                "description": element.description,
                "hours": element.hours,
                "total": element.total,
              }
              projHours.push(obj);
            }
          });
          for (var i = 0; i < projHours.length; i++) {
            for (var key in projHours[i]) {
              if (projectHourlycol.indexOf(key) === -1) {
                projectHourlycol.push(key);
              }
            }
          }
          for (var i = 0; i < projHours.length; i++) {
            var tableRow1 = document.getElementById('projectActivityJSON0')
            var table1 = document.getElementById("projectActivityTable"); // find table to append to
            var clone1 = tableRow1.cloneNode(true);
            clone1['id'] = "projectActivityJSON0" + (i + 1); // change id or other attributes/contents
            table1.appendChild(clone1)
            var name1 = `#projectActivityJSON0${i + 1} th`
            var data1 = document.querySelectorAll(name1)
            for (var j = 0; j < projectHourlycol.length; j++) {
              data1[j].innerHTML = projHours[i][projectHourlycol[j]]
            }
          }
          var projectFlatFreecol = [];
          var projFlatfree = [];
          projectScreenData.projectService.FlatFree.forEach(element => {
            if (element.total != '') {
              let obj = {
                "description": element.description,
                "total": element.total,
              }
              projFlatfree.push(obj);
            }
          });
          for (var i = 0; i < projFlatfree.length; i++) {
            for (var key in projFlatfree[i]) {
              if (projectFlatFreecol.indexOf(key) === -1) {
                projectFlatFreecol.push(key);
              }
            }
          }
          for (var i = 0; i < projFlatfree.length; i++) {
            var tableRow2 = document.getElementById('projectActivityJSON1')
            var table2 = document.getElementById("projectActivityTable1"); // find table to append to
            var clone2 = tableRow2.cloneNode(true);
            clone2['id'] = "projectActivityJSON1" + (i + 1); // change id or other attributes/contents
            table2.appendChild(clone2)
            var name2 = `#projectActivityJSON1${i + 1} th`
            var data2 = document.querySelectorAll(name2)
            for (var j = 0; j < projectFlatFreecol.length; j++) {
              data2[j].innerHTML = projFlatfree[i][projectFlatFreecol[j]]
            }
          }
          document.getElementById("courtesyDiscount").innerHTML = projectScreenData.projectService.courtesyDiscount;
          document.getElementById("TotalProjectActivity").innerHTML = projectScreenData.projectService.TotalProjectService;
          document.getElementById("feeTotalProjectActivity").innerHTML = projectScreenData.projectService.TotalProjectService;
          var projectHslwcol = [];
          var projectHslwTable = [];
          projectScreenData.Hslw.hslwTable.forEach(element => {
            if (element.extendedPrice != '') {
              let obj = {
                "qty": element.qty,
                "description": element.description,
                "unitPrice": element.unitPrice,
                "extended": element.extendedPrice
              }
              projectHslwTable.push(obj)
            }
          });
          for (var i = 0; i < projectHslwTable.length; i++) {
            for (var key in projectHslwTable[i]) {
              if (projectHslwcol.indexOf(key) === -1) {
                projectHslwcol.push(key);
              }
            }
          }
          for (var i = 0; i < projectHslwTable.length; i++) {
            var tableRow = document.getElementById('projectJSON0')
            var table = document.getElementById("tableToModify"); // find table to append to
            var clone = tableRow.cloneNode(true);
            clone['id'] = "projectJSON0" + (i + 1); // change id or other attributes/contents
            table.appendChild(clone)
            var name = `#projectJSON0${i + 1} td`
            var data = document.querySelectorAll(name)
            for (var j = 0; j < projectHslwcol.length; j++) {
              data[j].innerHTML = projectHslwTable[i][projectHslwcol[j]]
            }
          }
          document.getElementById("totalHslw").innerHTML = projectScreenData.Hslw.totalHslw;
          document.getElementById("feeTotalHslw").innerHTML = projectScreenData.Hslw.totalHslw;
            if (projectScreenData.projectService.TotalProjectService == '') {
              document.getElementById("projFeeSummaryActivity").style.display = 'none';
            }
            if (projectScreenData.Hslw.totalHslw == '') {
              document.getElementById("projFeeSummaryHSLW").style.display = 'none';
            }
            if (projectScreenData.projectService.courtesyDiscount == '') {
              document.getElementById("projectDiscount").style.display = 'none';
            }
            if (projectScreenData.Hslw.totalHslw == '') {
              document.getElementById("projectHSLW1").style.display = 'none';
              document.getElementById("projectHSLW2").style.display = 'none';
              document.getElementById("projectHSLW3").style.display = 'none';
            } else {
              tableRow.style.display = 'none';
            }
            if (projectScreenData.projectService.TotalProjectService == '') {
              document.getElementById("projectActivity1").style.display = 'none';
              document.getElementById("projectActivity2").style.display = 'none';
            }
            if (document.getElementById('projectActivityJSON0') != undefined) {
              document.getElementById('projectActivityJSON0').style.display = 'none';
            }
            if (document.getElementById('projectActivityJSON1') != undefined) {
              document.getElementById('projectActivityJSON1').style.display = 'none';
            }
        }
      } 
    }
  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Generating Pdf Please wait...',
      cssClass: 'loaderSpinner',
    });
    this.loader.present();
  }
  ngAfterViewInit() {
    let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate');
    this.loadComponent(index);
  }
  ngAfterViewChecked() {
    var viewData = JSON.parse(localStorage.getItem('ViewScreen'));
    let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalViewer')
    if (viewData != null) {
      this.componentService.tabTemplates[index].templates = viewData;
    }
  }
  loadComponent(idx) {
    let templateProperty: any;
    templateProperty = this.componentService.tabTemplates[idx];
    this.openTabComponent(templateProperty.templates[0]);
    setTimeout(() => {
      this.TitleScreen();
      this.projectActivity();
      this.MspScreenActivity();
      this.BackupDrScreenActivity();
      this.cyberScreenActivity();
      this.hwSwScreenActivity();
      this.cloudScreenActivity();
      this.MsaScreen();
      this.ServiceScreen();
    }, 100)
  }
  @ViewChild('Loadcomponent', { read: ViewContainerRef }) Loadcomponent: ViewContainerRef;
  openTabComponent(templateProperty) {
    this.showEdit = false;
    this.showPreview = false;
    this.showServiceScreen = false;
    this.showPage = true;
    this.dataService.showEdit = false;
    this.dataService.showSave = false;
    this.dataService.showPrint = false;
    this.dataService.showHeaderIcons = true;
    if (this.tabName == 'ProposalCreate' || this.tabName == 'PriceList' || this.tabName == 'Azure') {
      setTimeout(() => {
        const componentFactory = this.resolver.resolveComponentFactory(templateProperty.componentName);
        this.Loadcomponent.clear();
        if (componentFactory.selector == "hardware-software-sheet" || componentFactory.selector == "price-list" || componentFactory.selector == "cloud-pricing-sheet" || componentFactory.selector == "cover-screen" || componentFactory.selector == "page-pricelist-master") {
          document.getElementById('pageWidth').style.width = '95%';
        } else {
          if(componentFactory.selector == "page-msa" || componentFactory.selector == "page-sow" || componentFactory.selector == "page-sow-list"){
            document.getElementById('pageWidth').style.minHeight = 'unset';
            document.getElementById('pageWidth').style.height = '100%';
          }
          document.getElementById('pageWidth').style.width = '60%';
        }
        this.componentRef = this.Loadcomponent.createComponent(componentFactory);
      }, 100);
    } else {
      setTimeout(() => {
        this.htmlContent = templateProperty.componentName;
        var page = document.createElement("section")
        let ind = templateProperty.id;
        page.setAttribute('id', 'PreiviewCount' + ind);
        page.setAttribute('class', 'page');
        page.innerHTML = this.htmlContent;
        jQuery(".innerhtml").html(page);
        this.TitleScreen();
        this.projectActivity();
        this.MspScreenActivity();
        this.BackupDrScreenActivity();
        this.cyberScreenActivity();
        this.hwSwScreenActivity();
        this.cloudScreenActivity();
        this.MsaScreen();
        this.ServiceScreen();
      }, 100);
    }
    this.selectedPage = templateProperty
  }
  azureMarkup(event){
    if (event.target.value != '') {
      if (event.target.value.includes("%") == true) {
        this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup = parseFloat(event.target.value.slice(0, -1)).toFixed(2) + '%';
      } else {
        this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup = parseFloat(event.target.value).toFixed(2) + '%';
      }
    }else{
      this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup = '';
    }
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'AzureMarkup', params: this.dataService.ProposalTable.cloudPricingSheet.AzureServices.AzureMarkup});
    localStorage.setItem('CLOUDScreenData', JSON.stringify(this.dataService.ProposalTable.cloudPricingSheet));
  }
  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {
        return item;
      }
    };
    return null;
  }
  mergeCount = 0;
  callPDFService(url, params, s, e) {
    var obj: any = {};
    obj.data = JSON.stringify(params);
    var pa = JSON.stringify(obj);
    jQuery.support.cors = true;
    jQuery.ajax({
          type: 'POST'
        , url: url
        , data: pa
        , success: function (data) {
            s(data);
        }
        , contentType: "application/json; charset=utf-8;"
        , dataType: 'json'
    }).error(function (er) {
        e(er);
    });
}
  generatePDF(){
    var api = "https://time.starport.ca:62224/pdf/create/";
    this.gstyle = `<style>
    @media print{
    .PageContainer{
      page-break-after: always; 
      font-size: 18px !important;
    }
    #screenTable{
      font-size: 16px !important;
    }
    .PageContainer:last-child {
      page-break-after: avoid;
  }
    .TitlePageBorderCenter{
      width: 40.7% !important;
      padding: 50px !important;
    }
    ion-label{
      display: block;
      overflow: hidden;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .coverLetterHeader{
      display: table !important;
    }
    .coverletterSigCont{
      margin-top: 60px !important;
    }
    .TitlePageBorderCenterText{
      width: 35.1% !important;
      height: 51.4mm !important;
    }
    .TitlePageCenterText{
      padding-top: 10%;
    }
    .TitlePageBorder{
      border: 65px solid #ccc !important;
    }
    .text-center{
        text-align: center;
    }
    .text-left{
      text-align: left;
    }
    .text-right{
      text-align: right;
    }
  .CoverPageLogo{
    width: 20% !important;
  }
  table {border-collapse: unset;width: 100%;border-spacing: 0;}
  td, th {
        padding: 10px;
        background: white;
        box-sizing: border-box;
        font-size: 18px !important;
  }
  #CloudAzureTable0 th {
    padding-top: 20px !important;
    border: 1px solid #000 !important;
  }
  div{
    font-size: 18px !important;
  }
  thead th, td {
      position: sticky;
      top: 0;
      z-index: 2;
      font-weight: 500;
    }
    .pricingsheet_container{
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 50px;
  }
  }
    </style>`;
    for(var i = 0; i < this.mergePage.length; i++){
      let count = this.mergePage[i] - 1;
      this.htmlBodycontent += document.getElementById("PreiviewCount" + count).innerHTML;
    }
    var _html = "<html><head>" + this.gstyle + "</head><body>" + this.htmlBodycontent + "</body></html>";
   var fileName = this.pdfName.replace(".pdf","")
    this.callPDFService(api, {
          html: _html,
          pdf_config:{ 
            paperSize: {
              format: "A4"
              , orientation: "portrait",
              margin: "30px"
          },
        },
          filename: fileName,
      }, (data) => {
        this.publishContracts(data);
      }, (er) => {
        this.loader.dismiss();
          const toast = this.toastController.create({
            message: 'Error creating PDF!',
            duration: 1000,
          });
          toast.present();
      });
      this.htmlBodycontent = '';
  }
  publishContracts(data){
    this.loader.dismissAll();
    window.open(data.filename);
    if(this.publishCount != undefined){
      let ct = this.publishCount + 1;
      if(ct < this.dataService.publishContract.length){
      this.previewSowScreen(this.dataService.publishContract[ct], ct, true);
      }else{
        this.dataService.publishContract = [];
        const toast = this.toastController.create({
          message: 'Contract has been Published',
          duration: 1000,
        });
        toast.present();
        localStorage.setItem("MSPForm", JSON.stringify(this.dataService.ProposalTable.mspForm));
      }
    }
  }
  BackupDrScreenActivity() {
    var backupDrFormData = JSON.parse(localStorage.getItem('MSPForm'));
    var backupDrData = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
    if (backupDrFormData != null && document.getElementById("BackupDrNoOfUsers") != undefined) {
      document.getElementById("BackupDrNoOfUsers").innerHTML = backupDrFormData.noOfUsers;
      document.getElementById("BackupDrNoOfDevices").innerHTML = backupDrFormData.noOfDevices;
      document.getElementById("BackupDrNoOfLocations").innerHTML = backupDrFormData.noOfLocations;
      document.getElementById('backupdrClientName').innerHTML = ' - ' + backupDrFormData.ClientCompanyName;
      document.getElementById("BkpNoteClientCompanyName").innerHTML = backupDrFormData.ClientCompanyName;
    }
    if (backupDrData != null && document.getElementById("backupDrOneTimeDescribe") != undefined) {
      document.getElementById("BackupDrTotalOneTimeStartupFees").innerHTML = backupDrData.totalBackupDrServiceOneTimeFees;
      var totalBackupOneTimeFee = parseFloat(backupDrData.mspBackupDr.dattoOneTime != '' ? backupDrData.mspBackupDr.dattoOneTime.slice(1).replace(/  |,/gi,"") : '0') + parseFloat(backupDrData.mspBackupDr.intronisOneTime != '' ? backupDrData.mspBackupDr.intronisOneTime.slice(1).replace(/  |,/gi,"") : '0');
      document.getElementById("TotalBackupDrOneTime").innerHTML = '$' + totalBackupOneTimeFee.toFixed(2);
      document.getElementById("BackupDrTotalMonthlyFees").innerHTML = backupDrData.BackupFeesummaryTotaly;
      document.getElementById("BackupDrMonthlyFees").innerHTML = backupDrData.backupTools.totalBackupDrMonthlyTool;
      document.getElementById("backupDrMonthly").innerHTML = backupDrData.BackupFeesummaryTotaly;
      document.getElementById("backupDrOneTime").innerHTML = backupDrData.totalBackupDrServiceOneTimeFees;
      document.getElementById("BackupDrDiscountMonth").innerHTML = backupDrData.DiscountMonth;
      document.getElementById("backUpDrMonthlyDiscount").innerHTML = backupDrData.DiscountMonth;
      document.getElementById("backUpDrMonthlyDiscountVal").innerHTML = '-' + backupDrData.backupTools.backupProdTotalDiscount;
      document.getElementById("backUpDrOneTimeDiscntPercent").innerHTML = backupDrData.mspBackupDr.deviceCourtesyDiscount;
      document.getElementById("BkpBackupDrOneTimeDiscount").innerHTML = '-' + backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime;
      document.getElementById("BkpBackupDrSubtotal").innerHTML = backupDrData.mspBackupDr.TotalBackupDrOneTime;
      document.getElementById("backUpDrStartupSubtotal").innerHTML = backupDrData.oneTimeFee.subTotalStartUp;
      document.getElementById("backUpDrOneTimeDiscount").innerHTML = backupDrData.oneTimeFee.CourtesyDiscountOneTime;
      document.getElementById("BkpStartupOneTime").innerHTML = backupDrData.oneTimeFee.SetupConfigOneTime;
      document.getElementById("backupDrStartupDescribe").innerHTML = backupDrData.oneTimeFee.describeStartupFees != '' ?  backupDrData.oneTimeFee.describeStartupFees : 'One time activities to establish and test the Backup and Disaster Recovery framework.';
      var backuptools = '';
      backupDrData.backupTools.backupProdTable.forEach(element => {
        if (element.quantity != '') {
          backuptools += element.backUpProdName + ' -' + element.describe + ' (' + element.price + '), ';
        }
      });
      let datto = backupDrData.mspBackupDr.dattoMonthly != '' ? backupDrData.mspBackupDr.dattoDevicesOnly : '';
      let intronis = backupDrData.mspBackupDr.intronisMonthly != '' ? backupDrData.mspBackupDr.intronisDevicesOnly : '';
      let backupiFy = backupDrData.mspBackupDr.backupifyMonthly != '' ? backupDrData.mspBackupDr.backupifyDevicesOnly : '';
      if (backuptools != '' || datto != '' || intronis != '' || backupiFy != '') {
        let backp1 = datto != '' ? 'Datto - (' + datto + '), ' : '';
        let backp2 = intronis != '' ? 'Intronis - (' + intronis + '), ' : '';
        let backp3 = backupiFy != '' ? 'Backupify - (' + backupiFy + '), ' : '';
        document.getElementById("BackupDrBackupToolsLists").innerHTML = 'BACKUP TOOLS ' + backp1 + backp2 + backp3 + backuptools + ', monthly.';
      } else {
        document.getElementById("BackupDrBackupToolsLists").innerHTML = '';
      }
      let dattoDev = backupDrData.mspBackupDr.dattoOneTime != '' ? 'Datto - ' + backupDrData.mspBackupDr.noOfDattoDevices + ' Devices (' + backupDrData.mspBackupDr.dattoOneTime + '), ' : '';
      let intronisDev = backupDrData.mspBackupDr.intronisOneTime != '' ? 'Intronis - ' + backupDrData.mspBackupDr.noOfIntronisDevices + ' Devices (' + backupDrData.mspBackupDr.intronisOneTime  + '),' : '';
      document.getElementById("backupDrOneTimeDescribe").innerHTML = 'One-time Backup/DR Startup fees include: ' + dattoDev + intronisDev +  ' one time.';
      var BkpDescription = backupDrData.mspBackupDr.TotalBackupDrOneTime != '' ? 'Acquistion and configuration of selected backup and disaster recover (DR) devices. ' : '';
      var BkpDescription1 = backupDrData.oneTimeFee.subTotalStartUp != '' ? 'Setup, configuration and testing of the backup and disaster recovery (DR)environment. ' : '';
      var BkpDescription2 = backupDrData.backupTools.totalBackupDrMonthlyTool != '' ? 'Monthly licence fees and ongoing fees payable to product vendors for use of their backup disaster recovery (DR) devices, tools and/or software. ' : '';
      document.getElementById("BkpDescription1").innerHTML = BkpDescription + BkpDescription1 + BkpDescription2 + 'See Appendix A for a more detailed description of the products and services. ';
      setTimeout(() => {
      if(backupDrData.oneTimeFee.CourtesyDiscountOneTime == ''){
        document.getElementById("BackupdrStarup5").style.display = 'none';
      }
      if(backupDrData.oneTimeFee.SetupConfigOneTime == ''){
        document.getElementById("BackupdrStarup11").style.display = 'none';
        document.getElementById("BackupdrStarup3").style.display = 'none';
      }
      if(backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
        document.getElementById("BackupdrStarup9").style.display = 'none';
      }
      if(totalBackupOneTimeFee == DEFAULTINDEX){
        document.getElementById("BackupdrStarup8").style.display = 'none';
        document.getElementById("BackupdrStarup12").style.display = 'none';
      }
      if(backupDrData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
        document.getElementById("BackupdrStarup9").style.display = 'none';
      }
      if(backupDrData.oneTimeFee.subTotalStartUp == ''){
        document.getElementById("BackupdrStarup2").style.display = 'none';
        document.getElementById("BackupdrStarup3").style.display = 'none';
      }
      if(backupDrData.mspBackupDr.TotalBackupDrOneTime == ''){
        document.getElementById("BackupdrStarup6").style.display = 'none';
        document.getElementById("BackupdrStarup7").style.display = 'none';
        document.getElementById("BackupdrStarup13").style.display = 'none';
        document.getElementById("BackupdrStarup14").style.display = 'none';
      }
      if(backupDrData.totalBackupDrServiceOneTimeFees == ''){
        document.getElementById("BackupdrStarup1").style.display = 'none';
        document.getElementById("BackupdrStarup2").style.display = 'none';
        document.getElementById("BackupdrStarup3").style.display = 'none';
        document.getElementById("BackupdrStarup6").style.display = 'none';
        document.getElementById("BackupdrStarup7").style.display = 'none';
        document.getElementById("BackupdrStarup10").style.display = 'none';
      }
      if(backupDrData.backupTools.totalBackupDrMonthlyTool == ''){
        document.getElementById("BackupdrMonthly2").style.display = 'none';
        document.getElementById("BackupdrMonthly3").style.display = 'none';
      }
      if(backupDrData.backupTools.backupProdTotalDiscount == ''){
        document.getElementById("BackupdrMonthly6").style.display = 'none';
      }
      if(backupDrData.BackupFeesummaryTotaly == ''){
        document.getElementById("BackupdrMonthly1").style.display = 'none';
        document.getElementById("BackupdrMonthly2").style.display = 'none';
        document.getElementById("BackupdrMonthly3").style.display = 'none';
        document.getElementById("BackupdrMonthly4").style.display = 'none';
        document.getElementById("BackupdrMonthly5").style.display = 'none';
        document.getElementById("BackupdrMonthly6").style.display = 'none';
        document.getElementById("BackupdrMonthly7").style.display = 'none';
        document.getElementById("BackupdrMonthly8").style.display = 'none';
      }
      if(backupDrData.backupTools.backupProdTotalDiscount == ''){
        document.getElementById("showBkpDiscount").style.display = 'none';
      }
      }, 100)
    }
  }
  MsaScreen() {
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    if (mspFormData != null && document.getElementById("MsaScreenSignature") != undefined) {
      document.getElementById('msaStarportTitleLogo').setAttribute('src', this.dataService.StarportLogo);
      document.getElementById('MsaScreenSignature').setAttribute('src', this.dataService.UserSignature);
      document.getElementById("MsaCompanyName1").innerHTML = mspFormData.ClientCompanyName;
      document.getElementById('MsaClientName1').innerHTML = mspFormData.ClientFullName;
      document.getElementById('MsaClientCompName').innerHTML = mspFormData.ClientCompanyName;
      document.getElementById('MsaClientAddress').innerHTML = mspFormData.ClientAddress;
      if(mspFormData.ClientCity != ''){
        document.getElementById('MsaClientProvince').innerHTML = mspFormData.ClientCity + ', ' + mspFormData.ClientProvince + ' ' + mspFormData.ClientPostal;
      }
      let msadate = mspFormData.msaData.newDate != null ? mspFormData.msaData.newDate : mspFormData.msaData.existingDate;
      document.getElementById('MsaDate').innerHTML = msadate.split("-")[1] + ' ' + msadate.split("-")[0] + ', ' + msadate.split("-")[2];
      document.getElementById('MsaClientLastName').innerHTML = mspFormData.ClientLastName;
      if(document.getElementById('MsaClientSalutation') != null){
        document.getElementById('MsaClientSalutation').innerHTML = mspFormData.ClientSalutation;
      }
      document.getElementById('MsaUserName').innerHTML = mspFormData.userName;
      document.getElementById('MsaDesignation').innerHTML = mspFormData.userDesignation;
      document.getElementById('MsaFilename').innerHTML = this.pdfName;
    }
  }
  ServiceScreen() {
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    if (localStorage.getItem('TableContent') != null) {
      var tableCont = JSON.parse(localStorage.getItem('TableContent'));
      this.dataService.TableContent = tableCont
    }
    if (mspFormData != null && document.getElementById("ServiceCompanyDate") != undefined) {
          document.getElementById('starportTitleLogo').setAttribute('src', this.dataService.StarportLogo);
          document.getElementById('CoverPageLogo').setAttribute('src', this.dataService.StarportLogo);
          document.getElementById('ServiceScreenSignature').setAttribute('src', this.dataService.UserSignature);
      var dateFormat = mspFormData.startDate.split("-");
      document.getElementById('ServiceCompanyDate').innerHTML = dateFormat[1] + ' ' + dateFormat[0] + ', ' + dateFormat[2];
      document.getElementById('ServiceScreenCommenceDate').innerHTML = dateFormat[1] + ' ' + dateFormat[0] + ', ' + dateFormat[2];
      mspFormData.dashboard.forEach(element => {
        if (element.name == this.clickedSheet.name) {
          document.getElementById('ServiceSowNo').innerHTML = element.sowNo;
          document.getElementById('TitlePageSowNo').innerHTML = element.sowNo;
        }
      });
      var msadateFormat: any = [];
      if (mspFormData.msaData.newDate != null && mspFormData.msaData.newDate != '') {
        msadateFormat = mspFormData.msaData.newDate.split("-");
      } else if (mspFormData.msaData.existingDate != null && mspFormData.msaData.existingDate != '') {
        msadateFormat = mspFormData.msaData.existingDate.split("-");
      }
      document.getElementById('ServiceScreenMsaDate1').innerHTML = msadateFormat[1] + ' ' + msadateFormat[0] + ', ' + msadateFormat[2];
      document.getElementById('ServiceScreenMsaDate2').innerHTML = msadateFormat[1] + ' ' + msadateFormat[0] + ', ' + msadateFormat[2];
      if (document.getElementById('ServiceScreenCompanyName') != null) {
        document.getElementById('ServiceScreenCompanyName').innerHTML = mspFormData.ClientCompanyName;
      }
      document.getElementById('SowFilename1').innerHTML = this.pdfName;
      document.getElementById('SowFilename2').innerHTML = this.pdfName;
      this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
        if (element.name == this.clickedSheet.name) {
          document.getElementById('ProjectOptDescription').innerHTML = element.optionalDescription;
          document.getElementById('ServiceOptionalDescription').innerHTML = element.optionalDescription != '' ? '- ' + element.optionalDescription : '';
        }
        });
      // if (this.dataService.ClickedService.length == 1) {
        if (this.clickedSheet.name == 'MSP') {
          document.getElementById('ServiceProposalName').innerHTML = 'Managed IT Services';
          document.getElementById('ServiceProposalName1').innerHTML = 'Managed IT Services';
          document.getElementById('MspBilling').style.display = 'block';
          document.getElementById('MspToolsAppendix').style.display = 'block';
          document.getElementById('MspAppendixB').style.display = 'block';
          document.getElementById('MspDescription').style.display = 'block';
          var MspScreenData = JSON.parse(localStorage.getItem('MSPScreenData'));
          var MspBT = [];
          if (MspScreenData.mspBackupDr.dattoMonthly != '') {
            let obj = {
              "toolName": "Datto",
              "incl": MspScreenData.mspBackupDr.dattoIncl,
              "devices": MspScreenData.mspBackupDr.dattoDevicesOnly,
              "monthly": MspScreenData.mspBackupDr.dattoMonthly
            }
            MspBT.push(obj)
          }
          if (MspScreenData.mspBackupDr.intronisMonthly != '') {
            let obj = {
              "toolName": "Intronis",
              "incl": MspScreenData.mspBackupDr.intronisIncl,
              "devices": MspScreenData.mspBackupDr.intronisDevicesOnly,
              "monthly": MspScreenData.mspBackupDr.intronisMonthly
            }
            MspBT.push(obj)
          }
          if (MspScreenData.mspBackupDr.backupifyMonthly != '') {
            let obj = {
              "toolName": "Backupify",
              "incl": MspScreenData.mspBackupDr.backupifyIncl,
              "devices": MspScreenData.mspBackupDr.backupifyDevicesOnly,
              "monthly": MspScreenData.mspBackupDr.backupifyMonthly
            }
            MspBT.push(obj)
          }
          var MspBTCol = [];
          if (MspBT.length == 0) {
            document.getElementById('MspBackupToolsTable').style.display = 'none';
          } else {
            document.getElementById('MspBackupToolsTable').style.display = 'inline-table';
            for (var i = 0; i < MspBT.length; i++) {
              for (var key in MspBT[i]) {
                if (MspBTCol.indexOf(key) === -1) {
                  MspBTCol.push(key);
                }
              }
            }
            for (var i = 0; i < MspBT.length; i++) {
              var MspBTRow = document.getElementById('MspBTJSON0');
              var MspBTTable = document.getElementById("MspBTTable");
              var MspBTClone = MspBTRow.cloneNode(true);
              MspBTClone['id'] = "MspBTJSON0" + (i + 1);
              MspBTTable.appendChild(MspBTClone)
              var MspBTName = `#MspBTJSON0${i + 1} th`
              var MspBTData = document.querySelectorAll(MspBTName)
              for (var j = 0; j < MspBTCol.length; j++) {
                MspBTData[j].innerHTML = MspBT[i][MspBTCol[j]]
              }
            }
            document.getElementById('MspBTJSON0').style.display = 'none';
          }
          var MspOtherBPCol = [];
          var MspOtherBP = [];
          MspScreenData.backupTools.backupProdTable.forEach(element => {
            if (element.price != '') {
              let obj = {
                "backUpProdName": element.backUpProdName,
                "quantity": element.quantity,
                "price": element.price,
                "describe": element.describe,
                "monthly": element.monthly
              }
              MspOtherBP.push(obj)
            }
          });
          if (MspOtherBP.length == 0) {
            document.getElementById('MspOtherBackupProductTable').style.display = 'none';
          } else {
            document.getElementById('MspOtherBackupProductTable').style.display = 'inline-table';
            for (var i = 0; i < MspOtherBP.length; i++) {
              for (var key in MspOtherBP[i]) {
                if (MspOtherBPCol.indexOf(key) === -1) {
                  MspOtherBPCol.push(key);
                }
              }
            }
            for (var i = 0; i < MspOtherBP.length; i++) {
              var MspOtherBPRow = document.getElementById('MspOtherBPJSON0');
              var MspOtherBPTable = document.getElementById("MspOtherBPTable");
              var MspOtherBPClone = MspOtherBPRow.cloneNode(true);
              MspOtherBPClone['id'] = "MspOtherBPJSON0" + (i + 1);
              MspOtherBPTable.appendChild(MspOtherBPClone)
              var MspOtherBPName = `#MspOtherBPJSON0${i + 1} th`
              var MspOtherBPData = document.querySelectorAll(MspOtherBPName)
              for (var j = 0; j < MspOtherBPCol.length; j++) {
                MspOtherBPData[j].innerHTML = MspOtherBP[i][MspOtherBPCol[j]]
              }
            }
            document.getElementById('MspOtherBPJSON0').style.display = 'none';
          }
          var MspATCol = [];
          var MspAT = [];
          MspScreenData.additionalManagementTools.forEach(element => {
            if (element.incl == true) {
              let MiscellaneousObj = {
                "toolName": element.toolName,
                "incl": 1,
                "user": element.user,
                "device": element.device,
                "baseFree": element.baseFree,
                "ttlUser": element.ttlUser,
                "totalDevice": element.totalDevice,
                "subTotal": element.subTotal,
              }
              MspAT.push(MiscellaneousObj);
            }
          });
          if (MspAT.length == 0) {
            document.getElementById('MspAdditionalToolsTable').style.display = 'none';
          } else {
            document.getElementById('MspAdditionalToolsTable').style.display = 'inline-table';
            for (var i = 0; i < MspAT.length; i++) {
              for (var key in MspAT[i]) {
                if (MspATCol.indexOf(key) === -1) {
                  MspATCol.push(key);
                }
              }
            }
            for (var i = 0; i < MspAT.length; i++) {
              var MspATRow = document.getElementById('MspATJSON0');
              var MspAtTable = document.getElementById("MspATTable");
              var MspATClone = MspATRow.cloneNode(true);
              MspATClone['id'] = "MspATJSON0" + (i + 1);
              MspAtTable.appendChild(MspATClone)
              var MspATName = `#MspATJSON0${i + 1} th`
              var MspATData = document.querySelectorAll(MspATName)
              for (var j = 0; j < MspATCol.length; j++) {
                MspATData[j].innerHTML = MspAT[i][MspATCol[j]]
              }
            }
            document.getElementById('MspATJSON0').style.display = 'none';
          }
          var MspItCol = [];
          var MspIt = [];
          MspScreenData.itManagementTools.forEach(element => {
            if (element.incl == true) {
              let MiscellaneousObj = {
                "toolName": element.toolName,
                "incl": 1,
                "user": element.user,
                "device": element.device,
                "baseFree": element.baseFree,
                "ttlUser": element.ttlUser,
                "totalDevice": element.totalDevice,
                "subTotal": element.subTotal,
              }
              MspIt.push(MiscellaneousObj);
            }
          });
          if (MspIt.length == 0) {
            document.getElementById('MspItManagementToolsTable').style.display = 'none';
          } else {
            document.getElementById('MspItManagementToolsTable').style.display = 'inline-table';
            for (var i = 0; i < MspIt.length; i++) {
              for (var key in MspIt[i]) {
                if (MspItCol.indexOf(key) === -1) {
                  MspItCol.push(key);
                }
              }
            }
            for (var i = 0; i < MspIt.length; i++) {
              var MspItRow = document.getElementById('MspITJSON0');
              var MspItTable = document.getElementById("MspITTable");
              var MspItClone = MspItRow.cloneNode(true);
              MspItClone['id'] = "MspITJSON0" + (i + 1);
              MspItTable.appendChild(MspItClone)
              var MspItName = `#MspITJSON0${i + 1} th`
              var MspItDIta = document.querySelectorAll(MspItName)
              for (var j = 0; j < MspItCol.length; j++) {
                MspItDIta[j].innerHTML = MspIt[i][MspItCol[j]]
              }
            }
            document.getElementById('MspITJSON0').style.display = 'none';
          }
          var MspCTCol = [];
          var MspCT = [];
          MspScreenData.cyberTools.forEach(element => {
            if (element.incl == true) {
              let MiscellaneousObj = {
                "toolName": element.toolName,
                "incl": 1,
                "user": element.user,
                "device": element.device,
                "baseFree": element.baseFree,
                "ttlUser": element.ttlUser,
                "totalDevice": element.totalDevice,
                "subTotal": element.subTotal,
              }
              MspCT.push(MiscellaneousObj);
            }
          });
          if (MspCT.length == 0) {
            document.getElementById('MspCyberToolsTable').style.display = 'none';
          } else {
            document.getElementById('MspCyberToolsTable').style.display = 'inline-table';
            for (var i = 0; i < MspCT.length; i++) {
              for (var key in MspCT[i]) {
                if (MspCTCol.indexOf(key) === -1) {
                  MspCTCol.push(key);
                }
              }
            }
            for (var i = 0; i < MspCT.length; i++) {
              var MspCTRow = document.getElementById('MspCTJSON0');
              var MspCTTable = document.getElementById("MspCTTable");
              var MspCTClone = MspCTRow.cloneNode(true);
              MspCTClone['id'] = "MspCTJSON0" + (i + 1);
              MspCTTable.appendChild(MspCTClone)
              var MspCTName = `#MspCTJSON0${i + 1} th`
              var MspCTData = document.querySelectorAll(MspCTName)
              for (var j = 0; j < MspCTCol.length; j++) {
                MspCTData[j].innerHTML = MspCT[i][MspCTCol[j]]
              }
            }
            document.getElementById('MspCTJSON0').style.display = 'none';
          }
          if(MspCT.length == 0 && MspIt.length == 0 && MspAT.length == 0 && MspOtherBP.length == 0 && MspBT.length == 0){
            this.dataService.TableContent.forEach(element => {
              if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
                this.mergePage.splice(this.mergePage.length - 1, 1);
              }
            });
          }
        } else if (this.clickedSheet.name == 'CYB') {
          document.getElementById('CybBilling').style.display = 'block';
          document.getElementById('CyberAppendixB').style.display = 'block';
          document.getElementById('CyberToolsAppendix').style.display = 'block';
          document.getElementById('CyberDescription').style.display = 'block';
          document.getElementById('ServiceProposalName').innerHTML = 'CyberWatch - Managed Security Services';
          document.getElementById('ServiceProposalName1').innerHTML = 'CyberWatch - Managed Security Services';
          var CyberCtcol = [];
          var CyberCT = [];
          var cyberScreenData = JSON.parse(localStorage.getItem('CYBERScreenData'));
          cyberScreenData.cyberTools.forEach(element => {
            if (element.incl == true) {
              let ctObj = {
                "toolName": element.toolName,
                "incl": 1,
                "user": element.user,
                "device": element.device,
                "baseFree": element.baseFree,
                "ttlUser": element.ttlUser,
                "totalDevice": element.totalDevice,
                "subTotal": element.subTotal,
              }
              CyberCT.push(ctObj);
            }
          });
          if (CyberCT.length == 0) {
            document.getElementById('CyberCToolsTable').style.display = 'none';
          } else {
            for (var i = 0; i < CyberCT.length; i++) {
              for (var key in CyberCT[i]) {
                if (CyberCtcol.indexOf(key) === -1) {
                  CyberCtcol.push(key);
                }
              }
            }
            for (var i = 0; i < CyberCT.length; i++) {
              var CyberCtRow = document.getElementById('cyberCTJSON0');
              var CyberCtTable = document.getElementById("cyberCTTable");
              var CyberCtClone = CyberCtRow.cloneNode(true);
              CyberCtClone['id'] = "cyberCTJSON0" + (i + 1);
              CyberCtTable.appendChild(CyberCtClone)
              var CyberCtName = `#cyberCTJSON0${i + 1} th`
              var CyberCtData = document.querySelectorAll(CyberCtName)
              for (var j = 0; j < CyberCtcol.length; j++) {
                CyberCtData[j].innerHTML = CyberCT[i][CyberCtcol[j]]
              }
            }
            document.getElementById('cyberCTJSON0').style.display = 'none';
          }
          var AdditionalCtcol = [];
          var AdditionalCT = [];
          cyberScreenData.additionalManagementTools.forEach(element => {
            if (element.incl == true) {
              let ctObj = {
                "toolName": element.toolName,
                "incl": 1,
                "user": element.user,
                "device": element.device,
                "baseFree": element.baseFree,
                "ttlUser": element.ttlUser,
                "totalDevice": element.totalDevice,
                "subTotal": element.subTotal,
              }
              AdditionalCT.push(ctObj);
            }
          });
          if (AdditionalCT.length == 0) {
            document.getElementById('AdditionalCToolsTable').style.display = 'none';
          } else {
            for (var i = 0; i < AdditionalCT.length; i++) {
              for (var key in AdditionalCT[i]) {
                if (AdditionalCtcol.indexOf(key) === -1) {
                  AdditionalCtcol.push(key);
                }
              }
            }
            for (var i = 0; i < AdditionalCT.length; i++) {
              var AdditionalCtRow = document.getElementById('additionalCTJSON0');
              var AdditionalCtTable = document.getElementById("additionalCTTable");
              var AdditionalCtClone = AdditionalCtRow.cloneNode(true);
              AdditionalCtClone['id'] = "additionalCTJSON0" + (i + 1);
              AdditionalCtTable.appendChild(AdditionalCtClone)
              var AdditionalCtName = `#additionalCTJSON0${i + 1} th`
              var AdditionalCtData = document.querySelectorAll(AdditionalCtName)
              for (var j = 0; j < AdditionalCtcol.length; j++) {
                AdditionalCtData[j].innerHTML = AdditionalCT[i][AdditionalCtcol[j]]
              }
            }
            document.getElementById('additionalCTJSON0').style.display = 'none';
          }
          if(AdditionalCT.length == 0 && CyberCT.length == 0){
            this.dataService.TableContent.forEach(element => {
              if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
                this.mergePage.splice(this.mergePage.length - 1, 1);
              }
            });
          }
        } else if (this.clickedSheet.name == 'CLD') {
          document.getElementById('ServiceProposalName').innerHTML = 'Cloud and Hosting';
          document.getElementById('ServiceProposalName1').innerHTML = 'Cloud and Hosting';
          document.getElementById('CldBilling').style.display = 'block';
          document.getElementById('CloudAppendixB').style.display = 'block';
          document.getElementById('CloudToolsAppendix').style.display = 'block';
          document.getElementById('CloudDescription').style.display = 'block';
          var CloudIaasCol = [];
          var CloudIaas = [];
          var CloudScreenData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
          CloudScreenData.monthlyRecurring.IaaS.forEach(element => {
            if (element.Total != '') {
              let iaasObj = {
                "serverName": element.serverName,
                "base": element.base,
                "cpuQty": element.cpuQty,
                "cpuPrice": element.cpuPrice,
                "cpuSubTtl": element.cpuSubTtl,
                "ramQty": element.ramQty,
                "ramPrice": element.ramPrice,
                "ramSubTtl": element.ramSubTtl,
                "diskQty": element.diskQty,
                "diskPrice": element.diskPrice,
                "diskSubTtl": element.diskSubTtl,
              }
              CloudIaas.push(iaasObj);
            }
          });
          if (CloudIaas.length == 0) {
            document.getElementById('cloudIaaSTable').style.display = 'none';
          } else {
            for (var i = 0; i < CloudIaas.length; i++) {
              for (var key in CloudIaas[i]) {
                if (CloudIaasCol.indexOf(key) === -1) {
                  CloudIaasCol.push(key);
                }
              }
            }
            for (var i = 0; i < CloudIaas.length; i++) {
              var CloudIaasRow = document.getElementById('cloudIaaSJSON0');
              var CloudIaasTable = document.getElementById("cloudIaaSRow");
              var CloudIaasClone = CloudIaasRow.cloneNode(true);
              CloudIaasClone['id'] = "cloudIaaSJSON0" + (i + 1);
              CloudIaasTable.appendChild(CloudIaasClone)
              var CloudIaasName = `#cloudIaaSJSON0${i + 1} th`
              var CloudIaasData = document.querySelectorAll(CloudIaasName)
              for (var j = 0; j < CloudIaasCol.length; j++) {
                CloudIaasData[j].innerHTML = CloudIaas[i][CloudIaasCol[j]]
              }
            }
            document.getElementById('cloudIaaSJSON0').style.display = 'none';
          }
            var CloudSaasCol = [];
            var CloudSaas = [];
            CloudScreenData.monthlyRecurring.SaaS.forEach(element => {
              if (element.total != '') {
                let saasObj = {
                  "item": element.item,
                  "qty": element.qty,
                  "price": element.price,
                }
                CloudSaas.push(saasObj);
              }
            });
            if (CloudSaas.length == 0) {
              document.getElementById('cloudSaaSTable').style.display = 'none';
            } else {
              for (var i = 0; i < CloudSaas.length; i++) {
                for (var key in CloudSaas[i]) {
                  if (CloudSaasCol.indexOf(key) === -1) {
                    CloudSaasCol.push(key);
                  }
                }
              }
              for (var i = 0; i < CloudSaas.length; i++) {
                var CloudSaasRow = document.getElementById('cloudSaaSJSON0');
                var CloudSaasTable = document.getElementById("cloudSaaSRow");
                var CloudSaasClone = CloudSaasRow.cloneNode(true);
                CloudSaasClone['id'] = "cloudSaaSJSON0" + (i + 1);
                CloudSaasTable.appendChild(CloudSaasClone)
                var CloudSaasName = `#cloudSaaSJSON0${i + 1} th`
                var CloudSaasData = document.querySelectorAll(CloudSaasName)
                for (var j = 0; j < CloudSaasCol.length; j++) {
                  CloudSaasData[j].innerHTML = CloudSaas[i][CloudSaasCol[j]]
                }
              document.getElementById('cloudSaaSJSON0').style.display = 'none';
            }
          }
            var CloudMiscellaneousCol = [];
            var CloudMiscellaneous = [];
            CloudScreenData.monthlyRecurring.miscellaneous.forEach(element => {
              if (element.price != '') {
                let MiscellaneousObj = {
                  "tools": element.tools,
                  "price": element.price,
                  "description": element.description
                }
                CloudMiscellaneous.push(MiscellaneousObj);
              }
            });
            if (CloudMiscellaneous.length == 0) {
              document.getElementById('cloudMiscellaneousTable').style.display = 'none';
            } else {
              for (var i = 0; i < CloudMiscellaneous.length; i++) {
                for (var key in CloudMiscellaneous[i]) {
                  if (CloudMiscellaneousCol.indexOf(key) === -1) {
                    CloudMiscellaneousCol.push(key);
                  }
                }
              }
              for (var i = 0; i < CloudMiscellaneous.length; i++) {
                var CloudMiscellaneousRow = document.getElementById('cloudMiscellaneousJSON0');
                var CloudMiscellaneousTable = document.getElementById("cloudMiscellaneousRow");
                var CloudMiscellaneousClone = CloudMiscellaneousRow.cloneNode(true);
                CloudMiscellaneousClone['id'] = "cloudMiscellaneousJSON0" + (i + 1);
                CloudMiscellaneousTable.appendChild(CloudMiscellaneousClone)
                var CloudMiscellaneousName = `#cloudMiscellaneousJSON0${i + 1} th`
                var CloudMiscellaneousData = document.querySelectorAll(CloudMiscellaneousName)
                for (var j = 0; j < CloudMiscellaneousCol.length; j++) {
                  CloudMiscellaneousData[j].innerHTML = CloudMiscellaneous[i][CloudMiscellaneousCol[j]]
                }
              }
              document.getElementById('cloudMiscellaneousJSON0').style.display = 'none';
            }
          if(CloudMiscellaneous.length == 0 && CloudSaas.length == 0 && CloudIaas.length == 0){
            this.dataService.TableContent.forEach(element => {
              if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
                this.mergePage.splice(this.mergePage.length - 2, 1);
              }
            });
          }
        } else if (this.clickedSheet.name == 'BKP') {
          document.getElementById('ServiceProposalName').innerHTML = 'Backup and Disaster Recovery';
          document.getElementById('ServiceProposalName1').innerHTML = 'Backup and Disaster Recovery';
          document.getElementById('BkpBilling').style.display = 'block';
          document.getElementById('BkpAppendixB').style.display = 'block';
          document.getElementById('BkpToolsAppendix').style.display = 'block';
          document.getElementById('BkpDescription').style.display = 'block';
          var BkpScreenData = JSON.parse(localStorage.getItem('BACKUPDRsScreenData'));
          var BkpBT = [];
          if (BkpScreenData.mspBackupDr.dattoMonthly != '') {
            let obj = {
              "toolName": "Datto",
              "incl": BkpScreenData.mspBackupDr.dattoIncl,
              "devices": BkpScreenData.mspBackupDr.dattoDevicesOnly,
              "monthly": BkpScreenData.mspBackupDr.dattoMonthly
            }
            BkpBT.push(obj)
          }
          if (BkpScreenData.mspBackupDr.intronisMonthly != '') {
            let obj = {
              "toolName": "Intronis",
              "incl": BkpScreenData.mspBackupDr.intronisIncl,
              "devices": BkpScreenData.mspBackupDr.intronisDevicesOnly,
              "monthly": BkpScreenData.mspBackupDr.intronisMonthly
            }
            BkpBT.push(obj)
          }
          if (BkpScreenData.mspBackupDr.backupifyMonthly != '') {
            let obj = {
              "toolName": "Backupify",
              "incl": BkpScreenData.mspBackupDr.backupifyIncl,
              "devices": BkpScreenData.mspBackupDr.backupifyDevicesOnly,
              "monthly": BkpScreenData.mspBackupDr.backupifyMonthly
            }
            BkpBT.push(obj)
          }
          var BkpBTCol = [];
          if (BkpBT.length == 0) {
            document.getElementById('BkpBackupToolsTable').style.display = 'none';
          } else {
            for (var i = 0; i < BkpBT.length; i++) {
              for (var key in BkpBT[i]) {
                if (BkpBTCol.indexOf(key) === -1) {
                  BkpBTCol.push(key);
                }
              }
            }
            for (var i = 0; i < BkpBT.length; i++) {
              var BkpBTRow = document.getElementById('BkpBTJSON0');
              var BkpBTTable = document.getElementById("BkpBTTable");
              var BkpBTClone = BkpBTRow.cloneNode(true);
              BkpBTClone['id'] = "BkpBTJSON0" + (i + 1);
              BkpBTTable.appendChild(BkpBTClone)
              var BkpBTName = `#BkpBTJSON0${i + 1} th`
              var BkpBTData = document.querySelectorAll(BkpBTName)
              for (var j = 0; j < BkpBTCol.length; j++) {
                BkpBTData[j].innerHTML = BkpBT[i][BkpBTCol[j]]
              }
            }
            document.getElementById('BkpBTJSON0').style.display = 'none';
          }
          var BkpOtherBPCol = [];
          var BkpOtherBP = [];
          BkpScreenData.backupTools.backupProdTable.forEach(element => {
            if (element.price != '') {
              let obj = {
                "backUpProdName": element.backUpProdName,
                "quantity": element.quantity,
                "price": element.price,
                "describe": element.describe,
                "monthly": element.monthly
              }
              BkpOtherBP.push(obj)
            }
          });
          if (BkpOtherBP.length == 0) {
            document.getElementById('BkpOtherBPTable').style.display = 'none';
          } else {
            for (var i = 0; i < BkpOtherBP.length; i++) {
              for (var key in BkpOtherBP[i]) {
                if (BkpOtherBPCol.indexOf(key) === -1) {
                  BkpOtherBPCol.push(key);
                }
              }
            }
            for (var i = 0; i < BkpOtherBP.length; i++) {
              var BkpOtherBPRow = document.getElementById('BkpOtherBPJSON0');
              var BkpOtherBPTable = document.getElementById("BkpOtherBPTable");
              var BkpOtherBPClone = BkpOtherBPRow.cloneNode(true);
              BkpOtherBPClone['id'] = "BkpOtherBPJSON0" + (i + 1);
              BkpOtherBPTable.appendChild(BkpOtherBPClone)
              var BkpOtherBPName = `#BkpOtherBPJSON0${i + 1} th`
              var BkpOtherBPData = document.querySelectorAll(BkpOtherBPName)
              for (var j = 0; j < BkpOtherBPCol.length; j++) {
                BkpOtherBPData[j].innerHTML = BkpOtherBP[i][BkpOtherBPCol[j]]
              }
            }
            document.getElementById('BkpOtherBPJSON0').style.display = 'none';
          }
          if(BkpOtherBP.length == 0 && BkpBT.length == 0){
            this.dataService.TableContent.forEach(element => {
              if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
                this.mergePage.splice(this.mergePage.length - 1, 1);
              }
            });
          }
        } else if (this.clickedSheet.name == 'HW') {
          document.getElementById('ServiceProposalName').innerHTML = 'Hardware, Software, Licencing and Warranties';
          document.getElementById('ServiceProposalName1').innerHTML = 'Hardware, Software, Licencing and Warranties';
          document.getElementById('HwBilling').style.display = 'block';
          document.getElementById('HwAppendixB').style.display = 'block';
          document.getElementById('HwDescription').style.display = 'block';
          this.dataService.TableContent.forEach(element => {
            if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
              this.mergePage.splice(this.mergePage.length - 1, 1);
            }
          });
        } else if (this.clickedSheet.name == 'PJT') {
          document.getElementById('ServiceProposalName').innerHTML = 'Project Work';
          document.getElementById('ServiceProposalName1').innerHTML = 'Project Work';
          document.getElementById('PjtBilling').style.display = 'block';
          document.getElementById('ProjectAppendixB').style.display = 'block';
          if(mspFormData.longDescription != ''){
            document.getElementById('ProjectDescription').style.display = 'block';
            document.getElementById('ProjectLongDescription').innerHTML = mspFormData.longDescription;
          }
          var ProjectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
          var ProjectOtherBPCol = [];
          var ProjectOtherBP = [];
          ProjectScreenData.Hslw.hslwTable.forEach(element => {
            if (element.unitPrice != '') {
              let obj = {
                "qty": element.qty,
                "description": element.description,
                "unitCost": element.unitCost,
                "orMarkup": element.orMarkup,
                "unitPrice": element.unitPrice,
                "extendedPrice": element.extendedPrice
              }
              ProjectOtherBP.push(obj)
            }
          });
          if (ProjectOtherBP.length != 0) {
            document.getElementById('ProjectToolsAppendix').style.display = 'block';
            for (var i = 0; i < ProjectOtherBP.length; i++) {
              for (var key in ProjectOtherBP[i]) {
                if (ProjectOtherBPCol.indexOf(key) === -1) {
                  ProjectOtherBPCol.push(key);
                }
              }
            }
            for (var i = 0; i < ProjectOtherBP.length; i++) {
              var ProjectOtherBPRow = document.getElementById('ProjectActJSON0');
              var ProjectOtherBPTable = document.getElementById("ProjectTable");
              var ProjectOtherBPClone = ProjectOtherBPRow.cloneNode(true);
              ProjectOtherBPClone['id'] = "ProjectActJSON0" + (i + 1);
              ProjectOtherBPTable.appendChild(ProjectOtherBPClone)
              var ProjectOtherBPName = `#ProjectActJSON0${i + 1} th`
              var ProjectOtherBPData = document.querySelectorAll(ProjectOtherBPName)
              for (var j = 0; j < ProjectOtherBPCol.length; j++) {
                ProjectOtherBPData[j].innerHTML = ProjectOtherBP[i][ProjectOtherBPCol[j]]
              }
            }
            document.getElementById('ProjectActJSON0').style.display = 'none';
          }else{
            this.dataService.TableContent.forEach(element => {
              if(element.SectionId == 'Tools-Appendix' && element.IsChecked == true){
                // let ind = this.mergePage.length - 1;
                this.mergePage.splice(this.mergePage.length - 1, 1);
                // var elem = document.getElementById("PreiviewCount" + ind);
                // elem.remove();
              }
            });
          }
        }
      // }
      if (mspFormData.ClientLogo != null && mspFormData.ClientLogo != '') {
        document.getElementById('ServiceCompanyLogo').setAttribute('src', mspFormData.ClientLogo);
      } else {
        document.getElementById('ServiceCompanyLogo').style.display = 'none';
      }
      document.getElementById('ServiceScreenClientName').innerHTML = mspFormData.ClientFullName;
      document.getElementById('ServiceScreenClientCompName').innerHTML = mspFormData.ClientCompanyName;
      document.getElementById('ServiceScreenClientCompName1').innerHTML = mspFormData.ClientCompanyName;
      document.getElementById('ServiceScreenClientAddress').innerHTML = mspFormData.ClientAddress;
      if(mspFormData.ClientCity != ''){
      document.getElementById('ServiceScreenClientProvince').innerHTML = mspFormData.ClientCity + ', ' + mspFormData.ClientProvince;
      }
      document.getElementById('ServiceScreenClientPostal').innerHTML = mspFormData.ClientPostal;
      if(document.getElementById('ServiceScreenSalutation') != null){
        document.getElementById('ServiceScreenSalutation').innerHTML = mspFormData.ClientSalutation;
      }
      document.getElementById('ServiceScreenClientLastName').innerHTML = mspFormData.ClientLastName;
      document.getElementById('ServiceStartDate0').innerHTML = mspFormData.startDate.split("-")[1] + ' ' + mspFormData.startDate.split("-")[0] + ', ' + mspFormData.startDate.split("-")[2];;
      document.getElementById('ServiceUserName').innerHTML = mspFormData.userName;
      document.getElementById('ServiceDesignation').innerHTML = mspFormData.userDesignation;
    }
    this.dataService.ClickedService = [];
  }
  cloudScreenActivity() {
    var CloudFormData = JSON.parse(localStorage.getItem('MSPForm'));
    var cloudData = JSON.parse(localStorage.getItem('CLOUDScreenData'));
    if (CloudFormData != null && document.getElementById("CloudNoOfUsers") != undefined) {
      document.getElementById("CloudNoOfUsers").innerHTML = CloudFormData.noOfUsers;
      document.getElementById('cloudClientName').innerHTML = ' - ' + CloudFormData.ClientCompanyName;
    }
    if (cloudData != null && document.getElementById("CloudMonthlyFee") != undefined) {
      document.getElementById("cloudStartupDescribe").innerHTML = cloudData.startUpDescribe != '' ? cloudData.startUpDescribe : 'Conduct one time activities  to configure servers with specified disk, cpu and memory. Install and patch operating systems, configure firewalls, routers and vLans, setup access rights and permissions and communicate same to the client side technical community and end users.  Test to ensure access and security is functioning as expected.';
      document.getElementById("CloudSubtotalOneTime").innerHTML = cloudData.SetupConfigOneTime;
      document.getElementById("CloudCourtesyDiscount").innerHTML = '-' + cloudData.CourtesyDiscountOneTime;
      document.getElementById("CloudTotalOneTimeStartupFees").innerHTML = cloudData.TotalStartUp;
      document.getElementById("CloudSubtotalOneTime").innerHTML = cloudData.SetupConfigOneTime;
      document.getElementById("CloudSubtotalHostingServices").innerHTML = cloudData.monthlyRecurring.oneTime;
      document.getElementById("CloudMonthlyRecurringHours").innerHTML = cloudData.monthlyRecurring.oneTime;
      document.getElementById("cloudHostingServiceDescribe").innerHTML = cloudData.monthlyRecurring.describe != '' ? cloudData.monthlyRecurring.describe : 'Monitoring and responding to any server or network related alerts; monthy patching and reboots of all servers in the environment  capacity monitoring and adjustment based on server loads and carrying out adds, changes and deletes in the cloud infrastructure as requested/required.';
      document.getElementById("CloudAzureHostingDescribe").innerHTML = cloudData.monthlyRecurring.AzureServiceDescribe != '' ? cloudData.monthlyRecurring.AzureServiceDescribe : 'Azure production hosting, including Watchguard Firewalls in the production and DR environments and the DR environment using Site Recovery.';
      document.getElementById("CloudAzureHostingSubTotal").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
      document.getElementById("CloudAzureHostingSubTotal1").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
      var NoOfServer = [];
      cloudData.monthlyRecurring.IaaS.forEach(element => {
        if (element.serverName != '') {
          NoOfServer.push(element.base);
        }
      });
      document.getElementById("CloudNoOfServer").innerHTML = NoOfServer.length.toString();
      var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
      if (priceListData != null) {
        this.priceListTableService.priceList.CloudServerAndSW.server.SellValue = priceListData.CloudServerAndSW.server.SellValue;
        this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue = priceListData.CloudServerAndSW.cpu.SellValue;
        this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue = priceListData.CloudServerAndSW.ram.SellValue;
        this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue = priceListData.CloudServerAndSW.disk.SellValue;
      } else {
        if (this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn != '') {
          var diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        } else {
          diskVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.disk.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.disk.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        }
        if (this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn != '') {
          var ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        } else {
          ramVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.ram.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.ram.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        }
        if (this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn != '') {
          var cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        } else {
          cpuVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.cpu.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.cpu.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        }
        if (this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn != '') {
          var serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.newCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        } else {
          serverVal = parseFloat(this.priceListTableService.priceList.CloudServerAndSW.server.defCostCdn.slice(1).replace(/  |,/gi,"")) * (1 + ((this.priceListTableService.priceList.CloudServerAndSW.server.orPercent != '' ? this.priceListTableService.priceList.CloudServerAndSW.server.orPercent.slice(0, -1) : this.priceListTableService.priceList.TotalToolsMarkup.slice(0, -1)) / 100));
        }
        this.priceListTableService.priceList.CloudServerAndSW.server.SellValue = '$' + serverVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue = '$' + cpuVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue = '$' + ramVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue = '$' + diskVal.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      document.getElementById("serverVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.server.SellValue;
      document.getElementById("cpuVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.cpu.SellValue;
      document.getElementById("ramVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.ram.SellValue;
      document.getElementById("diskVal").innerHTML = this.priceListTableService.priceList.CloudServerAndSW.disk.SellValue;
      document.getElementById("TotalServerVal").innerHTML = cloudData.monthlyRecurring.TotalBase;
      document.getElementById("TotalCpuVal").innerHTML = cloudData.monthlyRecurring.TotalCpu;
      document.getElementById("TotalRamVal").innerHTML = cloudData.monthlyRecurring.TotalRam;
      document.getElementById("TotalDiskVal").innerHTML = cloudData.monthlyRecurring.TotalDisk;
      document.getElementById("CloudSubtotalInfraIaaS").innerHTML = cloudData.monthlyRecurring.SubtotalIaaS;
      var monthRecurringSaas = '';
      cloudData.monthlyRecurring.SaaS.forEach(element => {
        if (element.item != '' && element.qty != '') {
          monthRecurringSaas += 'Monthly Recurring Software (SaaS) : ' + element.item + ', (Qty: ' + element.qty + ' @ ' + element.price + '), ' + 'monthly.'
        }
      });
      document.getElementById("CloudSoftwareIaasDescribe").innerHTML = monthRecurringSaas;
      document.getElementById("CloudSubtotalSoftwareIaaS").innerHTML = cloudData.monthlyRecurring.SubTotalSaaS;
      var miscellaneous = [];
      cloudData.monthlyRecurring.miscellaneous.forEach(element => {
        var ToolDes = '';
        if (element.tools != '' || element.description != '') {
          ToolDes = ' : '
        } else {
          ToolDes = ''
        }
        if (element.price != '') {
          let obj = {
            "Service": element.tools + ToolDes + element.description,
            "Price": element.price
          }
          miscellaneous.push(obj);
        }
      });
      var Cloudcol = [];
      for (var i = 0; i < miscellaneous.length; i++) {
        for (var key in miscellaneous[i]) {
          if (Cloudcol.indexOf(key) === -1) {
            Cloudcol.push(key);
          }
        }
      }
      for (var i = 0; i < miscellaneous.length; i++) {
        var tableRow = document.getElementById('cloudJSON0')
        var table = document.getElementById("cloudTableToModify"); // find table to append to
        var clone = tableRow.cloneNode(true);
        clone['id'] = "cloudJSON0" + (i + 1); // change id or other attributes/contents
        table.appendChild(clone)
        var name = `#cloudJSON0${i + 1} th`
        var data = document.querySelectorAll(name)
        for (var j = 0; j < Cloudcol.length; j++) {
          data[j].innerHTML = miscellaneous[i][Cloudcol[j]]
        }
      }
      document.getElementById("CloudSubtotalOtherPS").innerHTML = cloudData.monthlyRecurring.SubTotalMiscellaneous;
      document.getElementById("CloudTotalMonthlyFees").innerHTML = cloudData.monthlyRecurring.TotalMonthlyRecurring;
      document.getElementById("CloudMonthlyFee").innerHTML = cloudData.FeesummaryMonthlyTotal;
      document.getElementById("CloudOneTImeFee").innerHTML = cloudData.TotalStartUp;
      document.getElementById("CloudDiscountMonth").innerHTML = cloudData.DiscountMonth;
      document.getElementById("ClouddiscountPerMonth").innerHTML = '-' + cloudData.monthlyRecurring.cloudMonthlyTotalDiscount;
      document.getElementById("CloudDiscountMonthSect").innerHTML = cloudData.DiscountMonth;
      var CloudDescription = cloudData.TotalStartUp != '' ? 'One time  activities  to establish your cloud and hosting framework,  commissioning servers with disk,cpu & memory, operating system installation/patching, firewall, router and vLan setup (including establishing access rights)  and testing of all hosted resources,  creation of IT documentation. Ongoing activities :  ' : '';
      var CloudDescription1 =  cloudData.monthlyRecurring.SubtotalIaaS != '' ? 'Provision  of all requested/required commissioned cloud/hosting resources. ' : '';
      var CloudDescription2 = cloudData.monthlyRecurring.oneTime != '' ? 'Monthly services for the management of commissioned cloud/hosting resources  - target & ' + parseInt(cloudData.monthlyRecurring.hours) + '  & hrs /month. ' : '';
      var CloudDescription3 = cloudData.monthlyRecurring.SubTotalSaaS != '' ? 'Monthly provision of all required software in the hosted environment (e.g. operating system licences).  ' : '';
      var CloudDescription4 = cloudData.monthlyRecurring.SubTotalMiscellaneous != '' ? 'Monthly provision of other miscellaneous required tools/services .  ' : '';
      document.getElementById("CloudDescription1").innerHTML = CloudDescription + CloudDescription1 + CloudDescription2 + CloudDescription3 + CloudDescription4 + 'See Appendix A for a detailed description of the products and services. ';
     if(cloudData.monthlyRecurring.AzureMonthly != ''){
      var CloudAzurecol = [];
      for (var i = 0; i < cloudData.AzureServices.AzureTable.length; i++) {
        for (var key in cloudData.AzureServices.AzureTable[i]) {
          if (CloudAzurecol.indexOf(key) === -1) {
            CloudAzurecol.push(key);
          }
        }
      }
      for (var i = 0; i < cloudData.AzureServices.AzureTable.length; i++) {
        var cloudtableRow = document.getElementById('CloudAzureRow0')
        var cloudtable = document.getElementById("CloudAzureTable0"); // find table to append to
        var cloudclone = cloudtableRow.cloneNode(true);
        cloudclone['id'] = "CloudAzureRow0" + (i + 1); // change id or other attributes/contents
        cloudtable.appendChild(cloudclone)
        var cloudname = `#CloudAzureRow0${i + 1} th`
        var clouddata = document.querySelectorAll(cloudname)
        for (var j = 0; j < CloudAzurecol.length; j++) {
          clouddata[j].innerHTML = cloudData.AzureServices.AzureTable[i][CloudAzurecol[j]]
        }
      }
      cloudtableRow.style.display = 'none';
      document.getElementById("CloudAzureSubtotal").innerHTML = cloudData.monthlyRecurring.AzureSubTotal;
      document.getElementById("CloudAzureTax").innerHTML = cloudData.monthlyRecurring.AzureTax;
      document.getElementById("CloudAzureTotal").innerHTML = cloudData.monthlyRecurring.AzureMonthly;
    }
      setTimeout(() => {
        if (cloudData.monthlyRecurring.TotalMonthlyRecurring == '' && document.getElementById('CloudMonthlyTable1') != null) {
          document.getElementById('CloudMonthlyTable1').style.display = 'none';
          document.getElementById('CloudMonthlyTable2').style.display = 'none';
        }
        if(cloudData.monthlyRecurring.cloudMonthlyTotalDiscount == ''){
          document.getElementById("CloudMonthlySect").style.display = 'none';
          document.getElementById('showCloudDiscount').style.display = 'none';
        }
        if(cloudData.monthlyRecurring.AzureMonthly == ''){
          document.getElementById("CloudAzureHosting").style.display = 'none';
          document.getElementById("CloudAzureHosting1").style.display = 'none';
        }
        if (cloudData.CourtesyDiscountOneTime == '') {
          document.getElementById('cloudCourtesyShow').style.display = 'none';
        }
        if (document.getElementById('cloudJSON0') != undefined && document.getElementById('cloudJSON0') != null) {
          document.getElementById('cloudJSON0').style.display = 'none';
        }
        if (cloudData.TotalStartUp == '') {
          document.getElementById('cloudStartup1').style.display = 'none';
          document.getElementById('cloudStartup2').style.display = 'none';
        }
        if (cloudData.monthlyRecurring.oneTime == '') {
          document.getElementById("CloudHosting1").style.display = 'none';
          document.getElementById("CloudHosting2").style.display = 'none';
          document.getElementById("CloudHosting3").style.display = 'none';
        }
        if (cloudData.monthlyRecurring.SubTotalSaaS == '') {
          document.getElementById("CloudIaaS1").style.display = 'none';
          document.getElementById("CloudIaaS2").style.display = 'none';
          document.getElementById("CloudIaaS3").style.display = 'none';
        }
        if (cloudData.monthlyRecurring.SubTotalMiscellaneous == '') {
          document.getElementById("CloudMiscellaneous1").style.display = 'none';
          document.getElementById("CloudMiscellaneous2").style.display = 'none';
        }
        if (cloudData.monthlyRecurring.SubtotalIaaS == '') {
          document.getElementById("CloudInfra1").style.display = 'none';
          document.getElementById("CloudInfra2").style.display = 'none';
          document.getElementById("CloudInfra3").style.display = 'none';
        }
      }, 100);
    }
  }
  hwSwScreenActivity() {
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    if (mspFormData != null && document.getElementById("hwswClientName") != undefined) {
      document.getElementById('hwswClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
    }
    var hwSwScreenData = JSON.parse(localStorage.getItem('HWSWScreenData'));
    if (hwSwScreenData != null && document.getElementById('HWSWTable') != undefined) {
      var hstVal = (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) * 0.13).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      if (hwSwScreenData.leaseOrPurchase == 'lease') {
        document.getElementById('HWSWFeeSummaryLP').innerHTML = 'See Lease Detail Above';
        document.getElementById('LeaseOrPurchase').innerHTML = 'Lease';
        document.getElementById('HWSWleaseDetail').innerHTML = '';
        document.getElementById('HWSWLeaseTotal').innerHTML = '';
        document.getElementById('HWSWLeaseHst').innerHTML = '';
        document.getElementById('HWSWHst').innerHTML = '';
        document.getElementById('HWSWTotal').innerHTML = '';
      } else if (hwSwScreenData.leaseOrPurchase == 'purchase') {
        document.getElementById('HidePurchase').style.display = 'none';
        document.getElementById('LeaseOrPurchase').innerHTML = 'Purchase';
        document.getElementById('HWSWFeeSummaryLP').innerHTML = 'Purchase Price';
        document.getElementById('HWSWleaseDetail').innerHTML = hwSwScreenData.TotalExtendedPrice;
        document.getElementById('HWSWHst').innerHTML = '$' + hstVal;
        document.getElementById('HWSWTotal').innerHTML = '$' + (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) + parseFloat(hstVal)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      } else {
        document.getElementById('HWSWFeeSummaryLP').innerHTML = 'See Lease Detail Above';
        document.getElementById('LeaseOrPurchase').innerHTML = 'Lease';
        document.getElementById('HWSWleaseDetail').innerHTML = hwSwScreenData.TotalExtendedPrice;
        document.getElementById('HWSWHst').innerHTML = '$' + hstVal;
        document.getElementById('HWSWTotal').innerHTML = '$' + (parseFloat(hwSwScreenData.TotalExtendedPrice.slice(1).replace(/  |,/gi,"")) + parseFloat(hstVal)).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      var hwswcol = [];
      var HwSwTableData = [];
      hwSwScreenData.contractLineItems.forEach(element => {
        if (element.extendedPrice != '') {
          let obj = {
            "qty": element.qty,
            "description": element.description,
            "unit": element.unitPrice,
            "extended": element.extendedPrice
          }
          HwSwTableData.push(obj);
        }
      });
      for (var i = 0; i < HwSwTableData.length; i++) {
        for (var key in HwSwTableData[i]) {
          if (hwswcol.indexOf(key) === -1) {
            hwswcol.push(key);
          }
        }
      }
      for (var i = 0; i < HwSwTableData.length; i++) {
        var tableRow1 = document.getElementById('HwSwRow0')
        var table1 = document.getElementById("HWSWTable");
        var clone1 = tableRow1.cloneNode(true);
        clone1['id'] = "HwSwRow0" + (i + 1);
        table1.appendChild(clone1)
        var name1 = `#HwSwRow0${i + 1} th`
        var data1 = document.querySelectorAll(name1)
        for (var j = 0; j < hwswcol.length; j++) {
          data1[j].innerHTML = HwSwTableData[i][hwswcol[j]]
        }
      }
      if (tableRow1 != undefined) {
        tableRow1.style.display = 'none';
      }
      document.getElementById('leaseOrPurchaseDescription').innerHTML = hwSwScreenData.leaseOrPurchaseDescription;
      document.getElementById('HWSWleaseLen').innerHTML = hwSwScreenData.Months;
      document.getElementById('HWSWduration').innerHTML = hwSwScreenData.OfDuration != '' ? hwSwScreenData.OfDuration : DEFAULTINDEX.toString();
      document.getElementById('HWSWfirstInvDate').innerHTML = hwSwScreenData.firstInvDate;
      document.getElementById('HWSWlastInvDate').innerHTML = hwSwScreenData.lastInvDate;
      document.getElementById('HWSWfirstLastMnthPmt').innerHTML = hwSwScreenData.firstLastMnthPmt;
      document.getElementById('HWSWregMonthPmt').innerHTML = hwSwScreenData.TotalMonthlyLeaseAmt;
      document.getElementById('HWSWnextMonths').innerHTML = hwSwScreenData.OfDuration != '' ? hwSwScreenData.OfDuration : DEFAULTINDEX.toString();
    }
  }
  cyberScreenActivity() {
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    var cyberScreenData = JSON.parse(localStorage.getItem('CYBERScreenData'));
    if (mspFormData != null && document.getElementById("CyberNoOfUsers") != undefined) {
      document.getElementById("CyberNoOfUsers").innerHTML = mspFormData.noOfUsers;
      document.getElementById("CyberNoOfDevices").innerHTML = mspFormData.noOfDevices;
      document.getElementById("CyberNoOfLocations").innerHTML = mspFormData.noOfLocations;
      document.getElementById('cyberClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
      document.getElementById('cyberNoteClientName').innerHTML = mspFormData.ClientCompanyName;
    }
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    if (priceListData != null && document.getElementById('CyberHourly') != undefined) {
      document.getElementById('CyberHourly').innerHTML = priceListData.TotalCyberHourly;
    } else if (priceListData == null && document.getElementById('CyberHourly') != undefined) {
      document.getElementById('CyberHourly').innerHTML = this.priceListTableService.priceList.defCyberHourly;
    }
    if (cyberScreenData != null && document.getElementById('CyberTotalmonthlyFee') != undefined) {
      document.getElementById("CyberTotalmonthlyFee").innerHTML = cyberScreenData.totalBackupDrMonthlyTool;
      document.getElementById("CyberOneTime").innerHTML = cyberScreenData.oneTimeFee.TotalStartUp;
      var CyberMonthlyTableVal = parseFloat(cyberScreenData.totalBackupDrMonthlyTool != '' ? cyberScreenData.totalBackupDrMonthlyTool.slice(1).replace(/  |,/gi,"") : '0') + parseFloat(cyberScreenData.backupProdTotalDiscount != '' ? cyberScreenData.backupProdTotalDiscount.slice(1).replace(/  |,/gi,"") :  '0');
      if(CyberMonthlyTableVal != DEFAULTINDEX){
        document.getElementById("CyberMMSMToolFee").innerHTML = '$' + CyberMonthlyTableVal.toFixed(2);
      }
      var additionalDevice = '';
      cyberScreenData.additionalManagementTools.forEach(element => {
        if (element.incl == true) {
          additionalDevice += element.description + ' ';
        }
      });
      if (additionalDevice != '') {
        document.getElementById("CyberAdditionalToolDescribe").innerHTML = 'ADDITIONAL TOOLS: Including: ' + additionalDevice.toLowerCase() + ' monthly';
      } else {
        document.getElementById("CyberAdditionalToolDescribe").innerHTML = '';
      }
      document.getElementById("CyberAToolServiceValue").innerHTML = cyberScreenData.subtotalAdditionalManagementTools.subTotalSubTotal;
      var cyberDevice = '';
      cyberScreenData.cyberTools.forEach(element => {
        if (element.incl == true) {
          cyberDevice += element.description + ' ';
        }
      });
      if (cyberDevice != '') {
        document.getElementById("CyberCToolDescribe").innerHTML = 'CYBER TOOLS/SERVICES: Including: ' + cyberDevice.toLowerCase() + ' monthly';
      } else {
        document.getElementById("CyberCToolDescribe").innerHTML = '';
      }
      // if(document.getElementById("CyberCToolServiceValue") != null){
        document.getElementById("CyberCToolServiceValue").innerHTML = cyberScreenData.subtotalCyberTools.subTotalSubTotal;
      // }
      if (document.getElementById('CyberAdditionalUsers') != null) {
        document.getElementById('CyberAdditionalUsers').innerHTML = cyberScreenData.additionalUsers;
      }
      if (document.getElementById('CyberAdditionalDevices') != null) {
        document.getElementById('CyberAdditionalDevices').innerHTML = cyberScreenData.additionalDevices;
      }
      document.getElementById('CyberDiscountMonthSect').innerHTML = cyberScreenData.DiscountMonth;
      document.getElementById('CyberdiscountPerMonth').innerHTML = '-' + cyberScreenData.backupProdTotalDiscount;
      document.getElementById('CyberDiscountMonth').innerHTML = cyberScreenData.DiscountMonth;
      document.getElementById('cyberDescribe').innerHTML = cyberScreenData.oneTimeFee.describeStartupFees != '' ? cyberScreenData.oneTimeFee.describeStartupFees : 'One time activities to implement security tools and processes to establish Cyber724 framework for the delivery of Managed Security Services.';
      document.getElementById('CyberSubtotalOneTime').innerHTML = cyberScreenData.oneTimeFee.SetupConfigOneTime;
      document.getElementById('CyberCourtesyDiscount').innerHTML = '-' + cyberScreenData.oneTimeFee.CourtesyDiscountOneTime;
      document.getElementById('CyberTotalOneTimeStartupFees').innerHTML = cyberScreenData.oneTimeFee.TotalStartUp;
      var withoutCyber: any = [];
      var CyberData1: any = '';
      var CyberData2: any = '';
      var CyberData3: any = '';
      var AdditionalData: any = '';
      cyberScreenData.cyberTools.forEach(elem => {
        if(elem.id != 'CyberWatch' && elem.id != 'CyberLearn'){
          withoutCyber.push(elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTINDEX);
        }else if(elem.id == 'CyberWatch' && elem.subTotal != ''){
          CyberData2 = 'Monthly provision of ongoing continuous cyber monitoring / notification and reaction services. '
        }else if(elem.id == 'CyberLearn' && elem.subTotal != ''){
          CyberData3 = 'Continous provision of an on-line learning program so that staff can build  cyber security awareness. '
        }
      });
      let val1 = withoutCyber.reduce(function (a, b) { return a + b; }, 0)
      if(val1 != DEFAULTINDEX){
        CyberData1 = 'Provision of tools to enable Starport technicians to  monitor cyber defence lines. '
      }
      var Additional: any = [];
      cyberScreenData.additionalManagementTools.forEach(elem => {
        Additional.push(elem.subTotal != '' ? parseFloat(elem.subTotal.slice(1).replace(/  |,/gi,"")) : DEFAULTINDEX);
      });
      let val3 = Additional.reduce(function (a, b) { return a + b; }, 0)
      if(val3 != DEFAULTINDEX){
        AdditionalData = 'Provision of MSP tools, such as anti-virus and anti-phishing, as a monthly service. '
      }
      var CyberDescription = cyberScreenData.oneTimeFee.TotalStartUp != '' ? 'One time  activities  to install tools, and test/document cyber framework processes. Ongoing Activities: ' : '';
      document.getElementById('CyberDescription1').innerHTML = CyberDescription + CyberData1 + AdditionalData + CyberData2 + CyberData3 + 'See Appendix A for a more detailed description of the products, MSP Cyber tools and services. ';
      setTimeout(() => {
        if(cyberScreenData.subtotalAdditionalManagementTools.subTotalSubTotal == ''){
          document.getElementById('CyberAToolTable').style.display = 'none';
        }
        if(cyberScreenData.subtotalCyberTools.subTotalSubTotal == ''){
          document.getElementById('CyberCToolTable').style.display = 'none';
        }
        if(CyberMonthlyTableVal == DEFAULTINDEX){
          document.getElementById('CyberCToolTable').style.display = 'none';
          document.getElementById('CyberAToolTable').style.display = 'none';
          document.getElementById('CyberMonthly1').style.display = 'none';
          document.getElementById('CyberMonthly2').style.display = 'none';
          document.getElementById('CyberMonthly3').style.display = 'none';
          document.getElementById('CyberMonthly4').style.display = 'none';
        }
        if (cyberScreenData.oneTimeFee.CourtesyDiscountOneTime == '') {
          document.getElementById('cyberStartup2Discount').style.display = 'none';
        }
        if(cyberScreenData.backupProdTotalDiscount == ''){
          document.getElementById('CyberMonthlySect').style.display = 'none';
          document.getElementById('cyberShowDisount').style.display = 'none';
        }
        if (cyberScreenData.oneTimeFee.TotalStartUp == '') {
          document.getElementById('cyberStartup1').style.display = 'none';
          document.getElementById('cyberStartup2').style.display = 'none';
        }
        if (cyberScreenData.backupProdTotalDiscount == '') {
          document.getElementById('CyberDiscountMonth').style.display = 'none';
        }
      }, 100)
    }
  }
  TitleScreen() {
    var mspData = JSON.parse(localStorage.getItem('MSPForm'));
    if (mspData && document.getElementById('companyDate') != undefined) {
      var dateFormat = mspData.startDate != null ? mspData.startDate.split("-") : [];
      document.getElementById('companyDate').innerHTML = dateFormat[1] + dateFormat[0] + ', ' + dateFormat[2];
      // if (this.dataService.ClickedService.length == 1) {
        if (this.clickedSheet.name == 'MSP') {
          document.getElementById('ProposalName').innerHTML = 'Managed IT Services';
        } else if (this.clickedSheet.name == 'CYB') {
          document.getElementById('ProposalName').innerHTML = 'CyberWatch - Managed Security Services';
        } else if (this.clickedSheet.name == 'CLD') {
          document.getElementById('ProposalName').innerHTML = 'Cloud and Hosting';
        } else if (this.clickedSheet.name == 'BKP') {
          document.getElementById('ProposalName').innerHTML = 'Backup and Disaster Recovery';
        } else if (this.clickedSheet.name == 'HW') {
          document.getElementById('ProposalName').innerHTML = 'Hardware, Software, Licencing and Warranties';
        } else if (this.clickedSheet.name == 'PJT') {
          document.getElementById('ProposalName').innerHTML = 'Project Work';
        }
      // }
      if (mspData.ClientLogo != null && mspData.ClientLogo != '') {
        document.getElementById('companyLogo').setAttribute('src', mspData.ClientLogo);
      } else {
        document.getElementById('companyLogo').style.display = 'none';
      }
    }
  }
  MspScreenActivity() {
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    var mspScreenData = JSON.parse(localStorage.getItem('MSPScreenData'));
    if (mspFormData != null && document.getElementById("noOfUsers") != undefined) {
      document.getElementById("noOfUsers").innerHTML = mspFormData.noOfUsers;
      document.getElementById("noOfDevices").innerHTML = mspFormData.noOfDevices;
      document.getElementById("NoOfUsers").innerHTML = mspFormData.noOfUsers;
      document.getElementById("NoOfDevices").innerHTML = mspFormData.noOfDevices;
      document.getElementById("noOfLocations").innerHTML = mspFormData.noOfLocations;
      document.getElementById('mspClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
      document.getElementById('mspMonthlyClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
      document.getElementById('MspNoteClientName').innerHTML = mspFormData.ClientCompanyName;
    }
    if (mspScreenData != null && document.getElementById("startUpDescribe") != undefined) {
      document.getElementById("startUpDescribe").innerHTML = mspScreenData.mspStartupFees.describe != '' ? mspScreenData.mspStartupFees.describe : 'One time activities to establish MSP framework include: Installation and configuration of monitoring & support tools, security account creation for remote access & creation of IT documentation & network and data maps available to us (and you) on the Starport portal';
      document.getElementById("startUpFees").innerHTML = mspScreenData.mspStartupFees.SetupConfigOneTime;
      document.getElementById("startUpCD").innerHTML = mspScreenData.mspStartupFees.CourtesyDiscountOneTime != '' ? '-' + mspScreenData.mspStartupFees.CourtesyDiscountOneTime : '';
      document.getElementById("startUpSubtotal").innerHTML = mspScreenData.mspStartupFees.subTotalStartUp;
      var hour = mspScreenData.mspMonthlyServices.remoteConnectingHour != '' ? parseInt(mspScreenData.mspMonthlyServices.remoteConnectingHour) : DEFAULTINDEX ;
      var hour1 = mspScreenData.mspMonthlyServices.endUserDesktopHour != '' ? parseInt(mspScreenData.mspMonthlyServices.endUserDesktopHour) : DEFAULTINDEX;
      var mspMonthlyDesVal = hour + hour1;
      var MspDescription = mspScreenData.mspStartupFees.subTotalStartUp != '' ? 'One time  activities  to establish an MSP framework,  such as our installation of standard support tools and the creation of IT documentation. ' : '';
      var MspDescription1 = mspScreenData.mspBackupDr.TotalBackupDrOneTime != '' ? 'One-time activities to establish and test a Backup/Disaster Recovery solution. ' : '';
      var MspDescription2 = mspScreenData.miscProductService.subTotalMiscOneTime != '' ? 'Provision of one-time products/licences as required/requested. Ongoing Activities: ' : '';
      var MspDescription3 = mspScreenData.mspMonthlyServices.TotalOneTimeEffort != '' ? 'Monthly delivery of Managed IT Services  - target ' + mspMonthlyDesVal + 'Monthly delivery of Managed IT Services  - target ' : '';
      var MspDescription4 = mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime != '' ? 'Provision of hardware, software and/or licences as a monthly service. ' : '';
      var MspDescription5 = mspScreenData.subtotalItManagementTools.subTotalSubTotal != '' ? 'Provision of IT Management software as a monthly service. ' : '';
      var MspDescription6 = mspScreenData.subtotalAdditionalManagementTools.subTotalSubTotal != '' ? 'Provision of Additonal Tools, such as anti-virus and cloud protection, as a monthly service. ' : '';
      var MspDescription7 = mspScreenData.subtotalCyberTools.subTotalSubTotal != '' ? 'Provision of Cyber tools as a monthly service. ' : '';
      var MspDescription8 = mspScreenData.backupTools.totalBackupMonthlyPrice != '' ? 'Provision of Backup  and/or Disaster Recovery Services as a monthly service. ' : '';
      if(document.getElementById("MspDescription1") != null){
        document.getElementById("MspDescription1").innerHTML = MspDescription + MspDescription1 + MspDescription2 + MspDescription3 + MspDescription4 + MspDescription5 + MspDescription6 + MspDescription7 + MspDescription8 + 'See Appendix A for a more detailed description of the  products, tools and services. ';
      }
      var mspBackupDrVal = (parseFloat(mspScreenData.mspBackupDr.TotalBackupDrOneTime != '' ? mspScreenData.mspBackupDr.TotalBackupDrOneTime.slice(1).replace(/  |,/gi,"") : DEFAULTINDEX.toString()) + parseFloat(mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime != '' ? mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime.slice(1).replace(/  |,/gi,"") : '0')).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      document.getElementById("backUpDrOneTime").innerHTML = '$' + mspBackupDrVal;
      if(mspScreenData.mspBackupDr.describe != ''){
        document.getElementById("backUpDrDescribe").innerHTML = mspScreenData.mspBackupDr.describe;
      }else{
        document.getElementById("backUpDrDescribe").innerHTML = 'One-time Backup/DR Startup fees include: Datto - '+ mspScreenData.mspBackupDr.noOfDattoDevices +' Device  Consisting of:' + mspScreenData.mspBackupDr.dattoDevicesAndPrice +  'Intronis - ' + mspScreenData.mspBackupDr.noOfIntronisDevices + ' Device (' + mspScreenData.mspBackupDr.intronisOneTime  + ') one time.';
      }
      document.getElementById("backUpDrCDVal").innerHTML = '-' + mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime;
      document.getElementById("backUpDrSubtotal").innerHTML = mspScreenData.mspBackupDr.TotalBackupDrOneTime;
      document.getElementById("backUpDrCD").innerHTML = mspScreenData.mspBackupDr.deviceCourtesyDiscount;
      document.getElementById("MspAdditionalUser").innerHTML = mspScreenData.additionalUsers;
      document.getElementById("MspAdditionalDevice").innerHTML = mspScreenData.additionalDevices;
      var miscProductServiceDescribe = ''
      mspScreenData.miscProductService.miscProductTable.forEach(element => {
        if (element.miscOneTimeFee != '' || element.rateAndPrice || element.qtyAndAmt) {
          miscProductServiceDescribe += 'One-time Misc. Product/Service Startup fees include:' + element.miscOneTimeFee + ', (Qty: ' + element.qtyAndAmt + '@ ' + element.rateAndPrice + ', ' + 'one time.'
        }
      });
      document.getElementById("miscOneTimeDescribe").innerHTML = mspScreenData.miscProductService.describe != '' ? mspScreenData.miscProductService.describe : miscProductServiceDescribe;
      document.getElementById("miscOneTimeVal").innerHTML = mspScreenData.miscProductService.subTotalMiscOneTime;
      document.getElementById("miscOneTimeSubtotal").innerHTML = mspScreenData.miscProductService.subTotalMiscOneTime;
      document.getElementById("TotalOneTimeStartupFees").innerHTML = mspScreenData.miscProductService.totalManagedServiceOneTimeFees;
      document.getElementById("MonthlyFeesDescribe").innerHTML = mspScreenData.mspMonthlyServices.describe1 != '' ? mspScreenData.mspMonthlyServices.describe1 : 'IT Managed Services Include: Server Support Remote / Connectivity (' + hour +' hrs/mo), End User / Desktop Managed Services (' + hour1 + ' hrs/mo),  - target ' + mspMonthlyDesVal + ' hrs /month of services in combination with support tools (see Tools section below), monthly. Overage Rate (when applicable) is ' + this.priceListTableService.priceList.TotalRateMsp + '/hr.';
      document.getElementById("remoteConnectingHour").innerHTML = mspScreenData.mspMonthlyServices.remoteConnectingHour;
      document.getElementById("remoteConnectingTotal").innerHTML = mspScreenData.mspMonthlyServices.RemoteConnectOneTime;
      document.getElementById("endUserDesktopHour").innerHTML = mspScreenData.mspMonthlyServices.endUserDesktopHour;
      document.getElementById("EndUserOneTime").innerHTML = mspScreenData.mspMonthlyServices.EndUserOneTime;
      document.getElementById("subtotalManagedItService").innerHTML = mspScreenData.mspMonthlyServices.TotalOneTimeEffort;
      var miscFeeDescribe = ''
      mspScreenData.mspMonthlyServices.miscMonthly.forEach(element => {
        if (element.monthlyHaasSass != '' || element.rateAndPrice || element.qtyAndAmt) {
          miscFeeDescribe += 'Ongoing Misc. Products/Services Include:' + element.monthlyHaasSass + ', (Qty: ' + element.qtyAndAmt + ' @ ' + element.rateAndPrice + ', ' + 'monthly.'
        }
      });
      document.getElementById("miscFeeDescribe").innerHTML = mspScreenData.mspMonthlyServices.describe2 != '' ? mspScreenData.mspMonthlyServices.describe2 : miscFeeDescribe;
      document.getElementById("miscFeeSubtotal").innerHTML = mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime;
      document.getElementById("standBtOfficeSpace").innerHTML = mspScreenData.mspMonthlyServices.standBtOfficeSpace;
      document.getElementById("miscFeeVal").innerHTML = '$' + (parseFloat(mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime ? mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime.slice(1).replace(/  |,/gi,"") : '0') - parseFloat(mspScreenData.mspMonthlyServices.standBtOfficeSpace != '' ? mspScreenData.mspMonthlyServices.standBtOfficeSpace.slice(1).replace(/  |,/gi,"") : '0')).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");;
      document.getElementById("itManagementVal").innerHTML = mspScreenData.subtotalItManagementTools.subTotalSubTotal;
      var itManagementDevice = '';
      mspScreenData.itManagementTools.forEach(element => {
        if (element.incl == true) {
          itManagementDevice += element.description + ' ';
        }
      });
      if (itManagementDevice != '') {
        document.getElementById("itManagementLists").innerHTML = 'IT MANAGEMENT TOOLS: Including: ' + itManagementDevice.toLowerCase() + ' monthly';
      } else {
        document.getElementById("itManagementLists").innerHTML = '';
      }
      var additionalDevice = '';
      mspScreenData.additionalManagementTools.forEach(element => {
        if (element.incl == true) {
          additionalDevice += element.description + ' ';
        }
      });
      if (additionalDevice != '') {
        document.getElementById("additionalLists").innerHTML = 'ADDITIONAL TOOLS: Including: ' + additionalDevice.toLowerCase() + ' monthly';
      } else {
        document.getElementById("additionalLists").innerHTML = '';
      }
      document.getElementById("additionalVal").innerHTML = mspScreenData.subtotalAdditionalManagementTools.subTotalSubTotal;
      var cyberDevice = '';
      mspScreenData.cyberTools.forEach(element => {
        if (element.incl == true) {
          cyberDevice += element.description + ' ';
        }
      });
      if (cyberDevice != '') {
        document.getElementById("cyberLists").innerHTML = 'CYBER TOOLS/SERVICES: Including: ' + cyberDevice.toLowerCase() + ' monthly';
      } else {
        document.getElementById("cyberLists").innerHTML = '';
      }
      document.getElementById("cyberVal").innerHTML = mspScreenData.subtotalCyberTools.subTotalSubTotal;
      document.getElementById("mspMonthly").innerHTML = mspScreenData.mspFeesummaryTotal;
      document.getElementById("mspOneTime").innerHTML = mspScreenData.miscProductService.totalManagedServiceOneTimeFees;
      document.getElementById("discountPerMonth").innerHTML = mspScreenData.backupTools.backupProdTotalDiscount != '' ? '-' + mspScreenData.backupTools.backupProdTotalDiscount : '';
      document.getElementById("SubtotalTools").innerHTML = mspScreenData.TotalMspToolSets;
      var TotalMspSetTools = (parseFloat(mspScreenData.TotalMspToolSets != '' ? mspScreenData.TotalMspToolSets.slice(1).replace(/  |,/gi,"") : '0')
        + parseFloat(mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime != '' ? mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime.slice(1).replace(/  |,/gi,"") : '0')
        + parseFloat(mspScreenData.mspMonthlyServices.TotalOneTimeEffort != '' ? mspScreenData.mspMonthlyServices.TotalOneTimeEffort.slice(1).replace(/  |,/gi,"") : "0"));
      document.getElementById("TotalMonthlyFees").innerHTML = TotalMspSetTools != DEFAULTINDEX ? '$' + TotalMspSetTools.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : '';
      var backuptools = '';
      mspScreenData.backupTools.backupProdTable.forEach(element => {
        if (element.quantity != '') {
          backuptools += element.backUpProdName + ' -' + element.describe + ' (' + element.price + '),';
        }
      });
      let datto = mspScreenData.mspBackupDr.dattoMonthly != '' ? (mspScreenData.mspBackupDr.dattoDevicesOnly + ' = ' + mspScreenData.mspBackupDr.dattoMonthly) : '';
      let intronis = mspScreenData.mspBackupDr.intronisMonthly != '' ? (mspScreenData.mspBackupDr.intronisDevicesOnly + ' = ' + mspScreenData.mspBackupDr.intronisMonthly) : '';
      let backupiFy = mspScreenData.mspBackupDr.backupifyMonthly != '' ? (' = ' + mspScreenData.mspBackupDr.backupifyMonthly) : '';
      if (backuptools != '' || datto != '' || intronis != '' || backupiFy != '') {
        let backp1 = datto != '' ? 'Datto: ' + datto + '. ' : '';
        let backp2 = intronis != '' ? 'Intronis: ' + intronis + '. ' : '';
        let backp3 = backupiFy != '' ? 'Backupify: ' + backupiFy + '. ' : '';
        document.getElementById("backupToolsLists").innerHTML = 'BACKUP TOOLS ' + backp1 + backp2 + backp3 + backuptools + ', monthly.';
      } else {
        document.getElementById("backupToolsLists").innerHTML = '';
      }
      document.getElementById("mspStandByOfficeVal").innerHTML = mspScreenData.mspMonthlyServices.standBtOfficeSpace;
      document.getElementById("backupToolsVal").innerHTML = mspScreenData.backupTools.totalBackupMonthlyPrice;
      document.getElementById("IncDiscountMonth").innerHTML = mspScreenData.DiscountMonth;
      document.getElementById("DiscountMonth").innerHTML = mspScreenData.DiscountMonth;
      setTimeout(() => {
        if (mspScreenData.mspMonthlyServices.EndUserOneTime == '' && document.getElementById('mspMonthlyManageEnd') != undefined) {
          document.getElementById('mspMonthlyManageEnd').style.display = 'none';
        }
        if (mspScreenData.miscProductService.subTotalMiscOneTime == '') {
          document.getElementById('mspMisc1').style.display = 'none';
          document.getElementById('mspMisc2').style.display = 'none';
          document.getElementById('mspMisc3').style.display = 'none';
        }
        if (mspScreenData.mspStartupFees.subTotalStartUp == '') {
          document.getElementById('mspManagedService1').style.display = 'none';
          document.getElementById('mspManagedService2').style.display = 'none';
        }
        if (mspScreenData.miscProductService.totalManagedServiceOneTimeFees == '') {
          document.getElementById('mspMisc1').style.display = 'none';
          document.getElementById('mspMisc2').style.display = 'none';
        }
        if (mspScreenData.mspMonthlyServices.TotalOneTimeEffort == '') {
          document.getElementById('MonthlyFeesDescribe').style.display = 'none';
          document.getElementById('mspMonthlyManageIt1').style.display = 'none';
          document.getElementById('mspMonthlyManageIt2').style.display = 'none';
          document.getElementById('mspMonthlyManageIt3').style.display = 'none';
        }
        if (mspScreenData.backupTools.backupProdTotalDiscount == '') {
          document.getElementById('MspMonthlySect').style.display = 'none';
        }
        if (mspScreenData.mspStartupFees.CourtesyDiscountOneTime == '') {
          document.getElementById('MSPShowStartupDiscount').style.display = 'none';
        }
        if (mspScreenData.mspMonthlyServices.standBtOfficeSpace == '') {
          document.getElementById("standBtOfficeSpaceReq").style.visibility = 'hidden';
        }
        if (mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime == '' && mspScreenData.mspMonthlyServices.standBtOfficeSpace == '') {
          document.getElementById('mspMiscFee1').style.display = 'none';
          document.getElementById('mspMiscFee2').style.display = 'none';
        } else if (mspScreenData.mspMonthlyServices.subTotalMonthlyOneTime == '') {
          document.getElementById('mspMiscFee1').style.display = 'none';
        }
        if(mspScreenData.mspBackupDr.deviceCourtesyDiscountOneTime == ''){
          document.getElementById("mspBackupDrDiscount").style.display = 'none';
        }
        if (TotalMspSetTools == DEFAULTINDEX) {
          document.getElementById('MSPMonthly1').style.display = 'none';
          document.getElementById('MSPMonthly2').style.display = 'none';
          document.getElementById('MSPMonthly3').style.display = 'none';
          document.getElementById('MSPMonthly4').style.display = 'none';
          document.getElementById('mspItAddCyberBackup2').style.display = 'none';
          document.getElementById('mspItAddCyberBackup1').style.display = 'none';
          document.getElementById('mspMiscFee2').style.display = 'none';
          document.getElementById('mspMiscFee1').style.display = 'none';
          document.getElementById('mspMonthlyManageIt3').style.display = 'none';
          document.getElementById('mspMonthlyManageIt2').style.display = 'none';
        }
        if (mspScreenData.subtotalItManagementTools.subTotalSubTotal == '') {
          document.getElementById('mspItManagement').style.display = 'none';
        }
        if (mspBackupDrVal == '' || mspBackupDrVal == "0.00") {
          document.getElementById('mspbackupDr1').style.display = 'none';
          document.getElementById('mspbackupDr2').style.display = 'none';
        }
        if (mspScreenData.subtotalAdditionalManagementTools.subTotalSubTotal == '') {
          document.getElementById('mspAdditional').style.display = 'none';
        }
        if (mspScreenData.subtotalCyberTools.subTotalSubTotal == '') {
          document.getElementById('mspCyber').style.display = 'none';
        }
        if (mspScreenData.backupTools.totalBackupMonthlyPrice == '') {
          document.getElementById('mspBackupTools').style.display = 'none';
        }
        if (mspScreenData.backupTools.backupProdTotalDiscount == '') {
          document.getElementById('showMspDiscount').style.display = 'none';
        }
        if (mspScreenData.TotalMspToolSets == '') {
          document.getElementById('mspItAddCyberBackup1').style.display = 'none';
          document.getElementById('mspItAddCyberBackup2').style.display = 'none';
        }
      }, 100)
    }
  }
  ngOnDestroy() {
    this.events.unsubscribe('previewMergePages');
    this.events.unsubscribe('previewAllPages');
    // this.events.unsubscribe('refreshData');
    this.events.unsubscribe('ProposalPreview');
    this.broadcastSubs.unsubscribe();
  }
  projectActivity() {
    var projectScreenData = JSON.parse(localStorage.getItem('ProjectScreen'));
    var mspFormData = JSON.parse(localStorage.getItem('MSPForm'));
    if (mspFormData != null && document.getElementById("projectClientName") != undefined) {
      document.getElementById('projectClientName').innerHTML = ' - ' + mspFormData.ClientCompanyName;
    }
    if (projectScreenData != null && document.getElementById('projectActivityTable') != undefined) {
      var projectHourlycol = [];
      var projHours = [];
      projectScreenData.projectService.Hourly.forEach(element => {
        if (element.total != '') {
          let obj = {
            "description": element.description,
            "hours": element.hours,
            "total": element.total,
          }
          projHours.push(obj);
        }
      });
      for (var i = 0; i < projHours.length; i++) {
        for (var key in projHours[i]) {
          if (projectHourlycol.indexOf(key) === -1) {
            projectHourlycol.push(key);
          }
        }
      }
      for (var i = 0; i < projHours.length; i++) {
        var tableRow1 = document.getElementById('projectActivityJSON0')
        var table1 = document.getElementById("projectActivityTable"); // find table to append to
        var clone1 = tableRow1.cloneNode(true);
        clone1['id'] = "projectActivityJSON0" + (i + 1); // change id or other attributes/contents
        table1.appendChild(clone1)
        var name1 = `#projectActivityJSON0${i + 1} th`
        var data1 = document.querySelectorAll(name1)
        for (var j = 0; j < projectHourlycol.length; j++) {
          data1[j].innerHTML = projHours[i][projectHourlycol[j]]
        }
      }
      var projectFlatFreecol = [];
      var projFlatfree = [];
      projectScreenData.projectService.FlatFree.forEach(element => {
        if (element.total != '') {
          let obj = {
            "description": element.description,
            "total": element.total,
          }
          projFlatfree.push(obj);
        }
      });
      for (var i = 0; i < projFlatfree.length; i++) {
        for (var key in projFlatfree[i]) {
          if (projectFlatFreecol.indexOf(key) === -1) {
            projectFlatFreecol.push(key);
          }
        }
      }
      for (var i = 0; i < projFlatfree.length; i++) {
        var tableRow2 = document.getElementById('projectActivityJSON1')
        var table2 = document.getElementById("projectActivityTable1"); // find table to append to
        var clone2 = tableRow2.cloneNode(true);
        clone2['id'] = "projectActivityJSON1" + (i + 1); // change id or other attributes/contents
        table2.appendChild(clone2)
        var name2 = `#projectActivityJSON1${i + 1} th`
        var data2 = document.querySelectorAll(name2)
        for (var j = 0; j < projectFlatFreecol.length; j++) {
          data2[j].innerHTML = projFlatfree[i][projectFlatFreecol[j]]
        }
      }
      document.getElementById("courtesyDiscount").innerHTML = projectScreenData.projectService.courtesyDiscount;
      document.getElementById("TotalProjectActivity").innerHTML = projectScreenData.projectService.TotalProjectService;
      document.getElementById("feeTotalProjectActivity").innerHTML = projectScreenData.projectService.TotalProjectService;
      var projectHslwcol = [];
      var projectHslwTable = [];
      projectScreenData.Hslw.hslwTable.forEach(element => {
        if (element.extendedPrice != '') {
          let obj = {
            "qty": element.qty,
            "description": element.description,
            "unitPrice": element.unitPrice,
            "extended": element.extendedPrice
          }
          projectHslwTable.push(obj)
        }
      });
      for (var i = 0; i < projectHslwTable.length; i++) {
        for (var key in projectHslwTable[i]) {
          if (projectHslwcol.indexOf(key) === -1) {
            projectHslwcol.push(key);
          }
        }
      }
      for (var i = 0; i < projectHslwTable.length; i++) {
        var tableRow = document.getElementById('projectJSON0')
        var table = document.getElementById("tableToModify"); // find table to append to
        var clone = tableRow.cloneNode(true);
        clone['id'] = "projectJSON0" + (i + 1); // change id or other attributes/contents
        table.appendChild(clone)
        var name = `#projectJSON0${i + 1} td`
        var data = document.querySelectorAll(name)
        for (var j = 0; j < projectHslwcol.length; j++) {
          data[j].innerHTML = projectHslwTable[i][projectHslwcol[j]]
        }
      }
      document.getElementById("totalHslw").innerHTML = projectScreenData.Hslw.totalHslw;
      document.getElementById("feeTotalHslw").innerHTML = projectScreenData.Hslw.totalHslw;
      setTimeout(() => {
        if (projectScreenData.projectService.TotalProjectService == '') {
          document.getElementById("projFeeSummaryActivity").style.display = 'none';
        }
        if (projectScreenData.Hslw.totalHslw == '') {
          document.getElementById("projFeeSummaryHSLW").style.display = 'none';
        }
        if (projectScreenData.projectService.courtesyDiscount == '') {
          document.getElementById("projectDiscount").style.display = 'none';
        }
        if (projectScreenData.Hslw.totalHslw == '') {
          document.getElementById("projectHSLW1").style.display = 'none';
          document.getElementById("projectHSLW2").style.display = 'none';
          document.getElementById("projectHSLW3").style.display = 'none';
        } else {
          tableRow.style.display = 'none';
        }
        if (projectScreenData.projectService.TotalProjectService == '') {
          document.getElementById("projectActivity1").style.display = 'none';
          document.getElementById("projectActivity2").style.display = 'none';
        }
        if (document.getElementById('projectActivityJSON0') != undefined) {
          document.getElementById('projectActivityJSON0').style.display = 'none';
        }
        if (document.getElementById('projectActivityJSON1') != undefined) {
          document.getElementById('projectActivityJSON1').style.display = 'none';
        }
      }, 100)
    }
  }

  clickPricingSheet(event, action) {
    if (action == 'RETURN_BACKUP_DR') {
    this.dataService.broadcastInfo({ src: 'proposal-create', event: 'GO_BACK', status: true});
      setTimeout(() => {
        this.PageHeader = true;
        this.ShowPageHeaderVal = true;
      }, 100)
    } else if (action == 'return') {
      this.dataService.showEdit = false;
      this.dataService.showHeaderIcons = true;
      let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate')
      let pageContent = this.componentService.tabTemplates[index].templates;
      this.tabName = 'ProposalCreate';
      this.componentService.tabName = 'ProposalCreate'
      this.openTabComponent(pageContent[0]);
        var tab = this.dataService.sheetName.toLowerCase() + 'ContractId';
        this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
          if (element.name == this.dataService.sheetName && element.fileName != '') {
            let obj = {
              "contract_file_1_Id": this.dataService[tab] != '' ? this.dataService[tab] : '',
              "Contract_Date": this.dataService.ProposalTable.mspForm.startDate,
              "Client_": this.dataService.ProposalTable.mspForm.ClientCode,
              "Contract_type": element.name,
              "Contract_Status": "InProgress",
              "Filename": element.fileName,
              "status": "",
              "Tag": "",
              "Created_date": "",
              "Created_By": "",
              "Modified_By": "",
              "Modified_date": "",
              "jsonData": this.dataService.ProposalTable,
              "userid": 3280,
              "rptname": "contract_file_12095",
              "client": "starport1294"
            }
            let objData = { data: JSON.stringify(obj) }
            this.configApiService.saveContract(objData).subscribe(respdata => {
              if (respdata["_POST_AddMethodResult"].length > 0) {
                if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
                  let resp = JSON.parse(respdata["_POST_AddMethodResult"][0].Ref_ID);
                  this.pricelistEntry(resp.contract_file_12095.contract_file_1_Id);
                  this.dataService[tab] = resp.contract_file_12095.contract_file_1_Id;
                }
              }
            });
          }
        });
    } else if (action == 'returnScreen') {
      let index = this.componentService.tabTemplates.findIndex(item => item.id == 'ProposalCreate')
      let pageContent = this.componentService.tabTemplates[index].templates;
      this.tabName = 'ProposalCreate';
      this.componentService.tabName = 'ProposalCreate';
      let ind = pageContent.findIndex(element => element.sheetId == this.dataService.goBack);
      this.openTabComponent(pageContent[ind]);
      this.dataService.broadcastInfo({ src: 'proposal-create', event: 'SCREEN_CALCULATION', status: true});
    } else if (action == 'priceList') {
      this.tabName = 'PriceList';
      this.componentService.tabName = 'PriceList'
      let obj = {
        "componentName": PriceListComponent
      }
      this.openTabComponent(obj);
    } else if(action == 'azureWs') {
      this.tabName = 'Azure';
      this.componentService.tabName = 'Azure';
      let obj = {
        "componentName" : AzureUploadComponent
      }
      this.openTabComponent(obj);
    } else if(action == 'preview'){
      this.dataService.ProposalTable.mspForm.dashboard.forEach(element => {
        if (element.name == this.dataService.sheetName) {
            this.dataService.ClickedService.push(this.dataService.sheetName);
            this.dataService.broadcastInfo({ src: 'proposal-view', event: 'PREVIEW_SOW', status: true ,params: this.dataService.sheetName});
        }
      });
    }
  }
  pricelistEntry(id){
    var priceListData: any;
    var priceListData = JSON.parse(localStorage.getItem('Pricelist'));
    let obj = {
      "Pricelist_Entry_1_Id": this.dataService.pricelistEntryId,
      "CLIENT_CODE": this.dataService.ProposalTable.mspForm.ClientCode,
      "USER_CODE": this.dataService.ProposalTable.mspForm.userCode,
      "CONTRACT_ID": id,
      "JSON_DATA": priceListData,
      "status":"",
      "Tag":"",
      "Created_date":"",
      "Created_By":"",
      "Modified_By":"",
      "Modified_date":"",
      "userid":3280,
      "rptname":"Pricelist_Entry_12528",
      "client":"starport1294"
    }
    let objData = { data: JSON.stringify(obj) }
      this.configApiService.saveContract(objData).subscribe(respdata => {
        if (respdata["_POST_AddMethodResult"].length > 0) {
          if (respdata["_POST_AddMethodResult"][0].Result !== "FAIL") {
            let resp = JSON.parse(respdata["_POST_AddMethodResult"][0].Ref_ID);
            this.dataService.pricelistEntryId = resp.Pricelist_Entry_12528.Pricelist_Entry_1_Id;
          }
        }
      });
  }
  UploadExcel(event){
    this.exportService.excelUpload(event);
    // this.driveServiceProvider.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/vertical-tab/vertical-tab.ts